import LangKeys from "./keys";

const mr = {
  [LangKeys.reminders_collect_faster]: "3 पट जलद पैसे वसूल करा",
  [LangKeys.reminders_total_dues]: "एकूण येणे बाकी",
  [LangKeys.reminders_all_customers]: "सर्व ग्राहक",
  [LangKeys.reminders_all]: "सर्व",
  [LangKeys.reminders_customers]: "ग्राहक",
  [LangKeys.reminders_suppliers]: "पुरवठादार",
  [LangKeys.reminders_search_placeholder]: "ग्राहकाचे नाव किंवा मोबाइल शोधा...",
  [LangKeys.reminders_pending_balance]: "बाकी रक्कम",
  [LangKeys.reminders_sent]: "पाठवले",
  [LangKeys.reminders_whatsapp]: "WhatsApp",
  [LangKeys.reminders_sms]: "SMS",
  [LangKeys.reminders_call]: "कॉल करा",
  [LangKeys.reminders_date]: "तारीख",
  [LangKeys.reminders_all_up_to_date]: "सर्व अद्ययावत आहे",
  [LangKeys.reminders_no_overdue_heading]: "कोणतेही थकीत ग्राहक आढळले नाहीत",
  [LangKeys.reminders_no_overdue_sub]: "छान! सर्व ग्राहकांचे पेमेंट वेळेवर आहे आणि कोणतेही थकीत नाही.",
  [LangKeys.reminders_view_all_customers]: "सर्व ग्राहक पहा",
  [LangKeys.reminders_no_due_today_heading]: "आज कोणतेही देय ग्राहक नाहीत",
  [LangKeys.reminders_no_due_today_sub]: "आजसाठी कोणतेही पेमेंट स्मरणपत्र शेड्यूल केलेले नाही.",
  [LangKeys.reminders_no_upcoming_heading]: "कोणतेही आगामी स्मरणपत्र नाही",
  [LangKeys.reminders_no_upcoming_sub]: "वेळेवर स्वयंचलित स्मरणपत्रे पाठवण्यासाठी संकलन तारीख सेट करा.",
  [LangKeys.reminders_no_customers_found]: "कोणतेही ग्राहक आढळले नाहीत",
  [LangKeys.reminders_no_customers_matched]: "आपल्या शोधानुसार कोणताही ग्राहक आढळला नाही.",
  [LangKeys.reminders_auto_reminder_active]: "ऑटो स्मरणपत्र सक्रिय",
  [LangKeys.reminders_overdue_by]: "थकीत दिवस",
  [LangKeys.reminders_due_in]: "बाकी दिवस",
  [LangKeys.reminders_days]: "दिवस",
  [LangKeys.reminders_day]: "दिवस",
  [LangKeys.reminders_set_collection_date]: "कलेक्शन तारीख सेट करा",
  [LangKeys.reminders_collect_faster_sub]: "ग्राहकांकडून जलद पेमेंट मिळवा",
  [LangKeys.reminders_pending_amount_filter]: "बाकी रक्कम फिल्टर (₹)",
  [LangKeys.reminders_highest_amount]: "सर्वाधिक रक्कम",
  [LangKeys.reminders_oldest_dues]: "सर्वात जुनी बाकी",
  [LangKeys.reminders_by_due_date]: "देय तारखेनुसार",
  [LangKeys.reminders_min]: "किमान",
  [LangKeys.reminders_max]: "कमाल",
  [LangKeys.reminders_to]: "ते",
  [LangKeys.reminders_customers_selected]: "ग्राहक निवडले",
  [LangKeys.reminders_total]: "एकूण",
  [LangKeys.reminders_set_due_date_selected]: "निवडलेल्या ग्राहकांसाठी तारीख निश्चित करा",
  [LangKeys.reminders_date_lbl]: "तारीख",
  [LangKeys.reminders_wa_sent_toast]: "{name} यांना WhatsApp स्मरणपत्र पाठवले!",
  [LangKeys.reminders_date_updated]: "स्मरणपत्र तारीख यशस्वीरित्या सेव्ह झाली!",

  [LangKeys.reminders_bulk_success]: "यशस्वीरित्या स्मरणपत्र पाठवले!",

  [LangKeys.reminders_sending]: "सेव्ह होत आहे...",

  [LangKeys.reminders_cloud_wa]: "क्लाउड WhatsApp API (ऑटो)",

  [LangKeys.reminders_direct_wa]: "थेट WhatsApp (मोफत वेब/अॅप)",

  [LangKeys.reminders_no_pending_desc]: "जेव्हा एखाद्या ग्राहकाकडून पैसे घ्यायचे असतील, तेव्हा ते येथे स्मरणपत्र यादीत दिसतील.",

  [LangKeys.reminders_no_pending]: "कोणतेही प्रलंबित स्मरणपत्र नाही",

  [LangKeys.reminders_clear_date]: "तारीख काढा",

  [LangKeys.reminders_save_date]: "तारीख सेव्ह करा",

  [LangKeys.reminders_time_lbl]: "वेळ",

  [LangKeys.reminders_chip_custom]: "कस्टम तारीख",

  [LangKeys.reminders_chip_1month]: "1 महिन्यानंतर",

  [LangKeys.reminders_chip_15days]: "15 दिवसांनंतर",

  [LangKeys.reminders_chip_1week]: "1 आठवड्यानंतर",

  [LangKeys.reminders_chip_3days]: "3 दिवसांनंतर",

  [LangKeys.reminders_chip_tomorrow]: "उद्या",

  [LangKeys.reminders_chip_today]: "आज",

  [LangKeys.reminders_days_left]: "दिवस शिल्लक",

  [LangKeys.reminders_days_overdue]: "दिवस उशीर",

  [LangKeys.reminders_not_sent]: "अजून पाठवले नाही",

  [LangKeys.reminders_last_sent]: "शेवटचे पाठवले",

  [LangKeys.reminders_auto_reminder_desc]: "शेड्यूल केलेल्या तारखेला आणि वेळेवर आपोआप स्मरणपत्र पाठवा",

  [LangKeys.reminders_auto_reminder]: "ऑटो स्मरणपत्र (Auto Send)",

  [LangKeys.reminders_send_all_whatsapp]: "सर्वांना एकाच वेळी व्हॉट्सअॅप पाठवा",

  [LangKeys.reminders_send_whatsapp]: "WhatsApp स्मरणपत्र पाठवा",

  [LangKeys.reminders_change_due_date]: "तारीख बदला",

  [LangKeys.reminders_set_due_date]: "देय तारीख सेट करा",

  [LangKeys.reminders_selected]: "निवडलेले",

  [LangKeys.reminders_select_all]: "सर्व निवडा",

  [LangKeys.reminders_search_hint]: "ग्राहकाचे नाव किंवा मोबाइल शोधा...",

  [LangKeys.reminders_no_date_tab]: "तारीख नाही",

  [LangKeys.reminders_upcoming_tab]: "आगामी",

  [LangKeys.reminders_overdue_tab]: "ओव्हरड्यू",

  [LangKeys.reminders_today_tab]: "आज",

  [LangKeys.reminders_all_tab]: "सर्व",

  [LangKeys.reminders_no_date]: "तारीख नाही",

  [LangKeys.reminders_upcoming]: "येणारे",

  [LangKeys.reminders_due_today]: "आज देय",

  [LangKeys.reminders_overdue]: "मुदत संपलेली",

  [LangKeys.reminders_total_outstanding]: "एकूण येणे बाकी",

  [LangKeys.reminders_subtitle]: "स्मार्ट हिशोबाने आपला व्यवसाय वाढवा.",

  [LangKeys.reminders_title]: "पेमेंट स्मरणपत्र",

  [LangKeys.processing]: "प्रक्रिया सुरू आहे...",

  [LangKeys.business_owner]: "व्यवसाय मालक",

  [LangKeys.moxpal_khata]: "मोक्सपाल खाता",

  [LangKeys.failed_load_dashboard]: "डॅशबोर्ड डेटा लोड करण्यात अयशस्वी",

  [LangKeys.delete_confirm]: "तुम्हाला खात्री आहे की तुम्ही हटवू इच्छिता?",

  [LangKeys.today]: "आज",

  [LangKeys.add_bill_terms_conditions_hint]: "अटी आणि शर्ती...",

  [LangKeys.stock]: "स्टॉक",

  [LangKeys.add_bill_item_price]: "किंमत",

  [LangKeys.add_bill_item_name]: "आयटमचे नाव",

  [LangKeys.parties]: "पार्ट्या",

  [LangKeys.address_area]: "परिसर / लँडमार्क",

  [LangKeys.address_flat_no]: "फ्लॅट / इमारत क्र.",

  [LangKeys.search_items_hint]: "आयटम शोधा...",

  [LangKeys.no_items_found]: "कोणतेही आयटम सापडले नाही",

  [LangKeys.loading]: "लोड होत आहे...",

  [LangKeys.edit_price_dialog_title]: "किंमत संपादित करा",

  [LangKeys.photos]: "फोटो",

  [LangKeys.notes]: "टिपा",

  [LangKeys.save_expense]: "खर्च जतन करा",

  [LangKeys.add_bill_payment_details]: "पेमेंट तपशील",

  [LangKeys.fields]: "फील्ड्स",

  [LangKeys.unpaid]: "थकीत (Unpaid)",

  [LangKeys.item_name_required]: "आयटमचे नाव आवश्यक आहे",

  [LangKeys.delete_confirmation]: "तुम्हाला खात्री आहे की तुम्ही हे हटवू इच्छिता?",

  [LangKeys.online_private]: "खाजगी (Private)",

  [LangKeys.online_active]: "ऑनलाइन मार्केटमध्ये सक्रिय",

  [LangKeys.app_name]: "मोक्षपाल खात",
  [LangKeys.header_subtitle]: "स्मार्ट बुककीपिंगसह तुमचा व्यवसाय वाढवा.",

  // SHARED KHATA
  [LangKeys.shared_khata__summary]: "खाते सारांश",
  [LangKeys.customer_name]: "ग्राहकाचे नाव",
  [LangKeys.mobile_no]: "मोबाईल नंबर",
  [LangKeys.transaction_history]: "व्यवहार इतिहास",
  [LangKeys.total_debit]: "एकूण डेबिट",
  [LangKeys.total_credit]: "एकूण क्रेडिट",
  [LangKeys.net_balance]: "निव्वळ शिल्लक",
  [LangKeys.date]: "तारीख",
  [LangKeys.credit]: "क्रेडिट",
  [LangKeys.debit]: "डेबिट",
  [LangKeys.balance]: "शिल्लक",
  [LangKeys.note]: "टीप",
  [LangKeys.call_support]: "सपोर्टला कॉल करा",
  [LangKeys.invalid_link]: "ही लिंक अवैध आहे किंवा कालबाह्य झाली आहे.",
  [LangKeys.footer]: "हे संगणकाने तयार केलेले स्टेटमेंट आहे आणि त्यासाठी कोणत्याही स्वाक्षरीची आवश्यकता नाही.",

  // COMMON
  [LangKeys.settings]: "सेटिंग्ज",
  [LangKeys.settings_subtitle]: "तुमचे ॲप्लिकेशन आणि व्यवसाय प्राधान्ये व्यवस्थापित करा",
  [LangKeys.language]: "भाषा",
  [LangKeys.select_language]: "भाषा निवडा",
  [LangKeys.close]: "बंद करा",
  [LangKeys.save]: "सेव्ह करा",
  [LangKeys.retry]: "पुन्हा प्रयत्न करा",
  [LangKeys.profile]: "प्रोफाइल संपादित करा",
  [LangKeys.logout]: "लॉगआउट",
  [LangKeys.version]: "आवृत्ती",
  [LangKeys.copyright]: "कॉपीराइट © मोक्सपाल खटा",
  [LangKeys.total]: "एकूण",
  [LangKeys.required_field]: "ही फील्ड आवश्यक आहे",
  [LangKeys.product]: "उत्पादन",

  [LangKeys.message_language]: "SMS भाषा",
  [LangKeys.follow_app]: "ॲपप्रमाणे",

  [LangKeys.hindi]: "हिंदी",
  [LangKeys.english]: "इंग्रजी",
  [LangKeys.hinglish]: "हिंग्लिश",
  [LangKeys.gujarati]: "गुजराती",
  [LangKeys.marathi]: "मराठी",
  [LangKeys.punjabi]: "पंजाबी",
  [LangKeys.tamil]: "तमिळ",
  [LangKeys.telugu]: "तेलुगू",

  // SETTINGS PAGE
  [LangKeys.business_settings]: "व्यवसाय सेटिंग्ज",
  [LangKeys.business_settings_desc]: "व्यवसाय प्रोफाइल, लोगो आणि GST तपशील",
  [LangKeys.staff_permissions]: "कर्मचारी आणि परवानग्या",
  [LangKeys.staff_permissions_desc]: "कर्मचारी प्रवेश आणि परवानग्या व्यवस्थापित करा",
  [LangKeys.backup_information]: "बॅकअप माहिती",
  [LangKeys.backup_information_desc]: "खाते डेटा निर्यात आणि पुनर्संचयित करा",
  [LangKeys.delete_khata]: "खाते हटवा",
  [LangKeys.delete_khata_desc]: "सर्व व्यवसाय डेटा कायमचा काढून टाका",
  [LangKeys.app_update]: "ॲप अपडेट",
  [LangKeys.app_update_desc]: "नवीनतम आवृत्तीसाठी तपासा",
  [LangKeys.app_up_to_date]: "अ‍ॅप अद्ययावत आहे",
  [LangKeys.failed_to_check_for_update]: "अपडेट तपासण्यात अयशस्वी",
  [LangKeys.whatsapp_service]: "Whatsapp अलर्ट्स आणि क्रेडिट्स",
  [LangKeys.whatsapp_service_desc]: "ग्राहकांना आपोआप पेमेंट रिमाइंडर पाठवा आणि क्रेडिट्स व्यवस्थापित करा",

  /* ================= Whatsapp SMS Credtits PAGE ================= */
  [LangKeys.whatsapp_credits]: "व्हॉट्सअॅप क्रेडिट्स",
  [LangKeys.available_credits]: "उपलब्ध क्रेडिट्स",
  [LangKeys.whatsapp_balance]: "व्हॉट्सअॅप संदेश बॅलन्स",
  [LangKeys.used]: "वापरलेले",
  [LangKeys.credits]: "क्रेडिट्स",
  [LangKeys.proceed_to_pay]: "पेमेंट करा",
  [LangKeys.recharge_plans]: "रिचार्ज प्लॅन्स",
  [LangKeys.off]: "बंद",

  [LangKeys.load_failed]: "लोड अयशस्वी झाले",
  [LangKeys.toggle_failed]: "टॉगल अयशस्वी झाले",
  [LangKeys.order_failed]: "ऑर्डर अयशस्वी झाले",
  [LangKeys.payment_error]: "पेमेंट एरर आला",
  [LangKeys.payment_failed]: "पेमेंट अयशस्वी झाले",
  [LangKeys.verification_failed]: "व्हेरिफिकेशन अयशस्वी झाले",
  [LangKeys.recharge_successful]: "रिचार्ज यशस्वी झाले",
  [LangKeys.total_purchased]: "एकूण खरेदी केलेले",
  [LangKeys.premium_unlimited_active]: "अमर्याद WhatsApp अलर्ट्स सक्रिय आहेत! 🎉",
  [LangKeys.premium_unlimited_desc]: "आपण Moxpal Khata च्या सर्वोत्तम 'Premium Plan' चे सक्रिय सदस्य आहात! आपल्याला अमर्याद ऑटो WhatsApp आणि SMS अलर्ट्स पूर्णपणे मोफत देण्यात आले आहेत.",


  /* ================= BACKUP INFORMATION ================= */
  [LangKeys.backup_info_text]: "तुमचा फोन इंटरनेटशी कनेक्ट केलेला असताना तुमचा डेटा आपोआप बॅकअप होतो. तुम्ही तुमचा फोन फॉरमॅट केल्यास किंवा ॲप हटविल्यास, फक्त तुमच्या नोंदणीकृत नंबरचा वापर करून पुन्हा लॉग इन करा. तुमचा डेटा आपोआप पुनर्संचयित केला जाईल.",
  [LangKeys.last_backup_at]: "शेवटचा बॅकअप",

  /* ================= DELETE / KHATA ================= */
  [LangKeys.delete_warning_text]: "तुम्ही हा व्यवसाय हटवणार आहात. तुमचा सर्व डेटा रीसायकल बिनमध्ये हलवला जाईल. तुम्ही तो 30 दिवसांच्या आत पुनर्संचयित करू शकता.",
  [LangKeys.delete_placeholder]: "पुष्टी करण्यासाठी व्यवसायाचे नाव टाइप करा",
  [LangKeys.delete_button]: "हटवा",
  [LangKeys.delete_name_mismatch]: "व्यवसायाचे नाव जुळत नाही.",

  // ================= KHATA =================
  [LangKeys.my_khata]: "माझे खाते",
  [LangKeys.search_customer]: "ग्राहक शोधा",
  [LangKeys.all_customers]: "सर्व ग्राहक",
  [LangKeys.no_customers_found]: "कोणताही ग्राहक आढळला नाही",
  [LangKeys.no_suppliers_found]: "कोणताही पुरवठादार आढळला नाही",
  [LangKeys.no_parties_found]: "कोणतेही पक्ष सापडले नाहीत",

  [LangKeys.just_now]: "आत्ताच",
  [LangKeys.min_ago]: "{value} मिनिटांपूर्वी",
  [LangKeys.hr_ago]: "{value} तासांपूर्वी",
  [LangKeys.day_ago]: "{value} दिवसांपूर्वी",
  [LangKeys.month_ago]: "{value} महिन्यांपूर्वी",
  [LangKeys.year_ago]: "{value} वर्षांपूर्वी",

  [LangKeys.settled]: "हिशोब बरोबर",
  [LangKeys.advance]: "जमा रक्कम",
  [LangKeys.due]: "उधार",
  [LangKeys.no_transactions]: "कोणताही व्यवहार नाही",
  [LangKeys.no_entries_yet]: "अजून कोणतीही नोंद नाही",
  [LangKeys.new_label]: "नवीन",

  /* ================= DASHBOARD / HOME SCREEN ================= */
  [LangKeys.khata]: "खाते",
  [LangKeys.you_will_get]: "तुम्हाला मिळतील",
  [LangKeys.you_will_give]: "तुम्ही द्याल",
  [LangKeys.search_khata_entry]: "खाते एंट्री शोधा",
  [LangKeys.recent_entries]: "अलीकडील नोंदी",
  [LangKeys.unknown_party]: "अज्ञात पक्ष",
  [LangKeys.unknown_customer]: "अज्ञात ग्राहक",
  [LangKeys.unknown]: "अज्ञात",

  // CUSTOMER LEDGER
  [LangKeys.ledger]: "खातेवही",
  [LangKeys.report]: "अहवाल",
  [LangKeys.reminder]: "स्मरणपत्र",
  [LangKeys.sms]: "एसएमएस",
  [LangKeys.whatsapp]: "व्हॉट्सॲप",
  [LangKeys.outstanding_balance]: "बाकी रक्कम",
  [LangKeys.total_balance]: "एकूण शिल्लक",
  [LangKeys.you_got]: "तुम्हाला मिळाले",
  [LangKeys.you_gave]: "तुम्ही दिले",
  [LangKeys.entries]: "नोंदी",
  [LangKeys.no_entries_found]: "कोणत्याही नोंदी आढळल्या नाहीत",
  [LangKeys.i_got]: "मला मिळाले",
  [LangKeys.i_gave]: "मी दिले",
  [LangKeys.you_got_caps]: "तुम्हाला मिळाले",
  [LangKeys.you_gave_caps]: "तुम्ही दिले",
  [LangKeys.wa_dear]: "प्रिय",
  [LangKeys.wa_account_update]: "मोक्षपाल खाते कडून तुमचे खाते अपडेट येथे आहे.",
  [LangKeys.total_due]: "एकूण बाकी रक्कम",
  [LangKeys.view_full_account]: "संपूर्ण खाते स्टेटमेंट पहा",
  [LangKeys.failed_to_load_data]: "डेटा लोड करण्यात अयशस्वी.",
  [LangKeys.could_not_open_whatsapp]: "WhatsApp उघडू शकलो नाही.",
  [LangKeys.could_not_open_sms]: "SMS ॲप उघडू शकलो नाही.",
  [LangKeys.total_purchase]: "एकूण खरेदी",
  [LangKeys.total_received]: "एकूण प्राप्त",

  [LangKeys.entry_success]: "नोंद यशस्वी झाली",
  [LangKeys.transaction_success]: "व्यवहार यशस्वी झाला",
  [LangKeys.done]: "पूर्ण झाले",

  // ENTRY
  [LangKeys.entry_details]: "नोंद तपशील",
  [LangKeys.running_balance]: "चालू शिल्लक",
  [LangKeys.share]: "शेअर करा",
  [LangKeys.network_error]: "नेटवर्क त्रुटी",
  [LangKeys.copy_link]: "लिंक कॉपी करा",
  [LangKeys.delete_entry]: "नोंद हटवा",
  [LangKeys.delete_entry_confirm]: "तुम्ही ही नोंद खरोखर हटवू इच्छिता?",
  [LangKeys.delete_entry_warning]: "ही क्रिया पूर्ववत केली जाऊ शकत नाही.",
  [LangKeys.edit_entry]: "नोंद संपादित करा",
  [LangKeys.invalid_entry]: "अवैध नोंद",
  [LangKeys.entry_not_found]: "नोंद आढळली नाही",
  [LangKeys.invalid_entry_type]: "अवैध नोंद प्रकार",
  [LangKeys.invalid_amount]: "अवैध रक्कम",
  [LangKeys.invalid_date]: "अवैध तारीख",
  [LangKeys.photo_size_error]: "फोटोचा आकार 1MB पेक्षा कमी असावा",
  [LangKeys.invalid_image_format]: "हा फोटो फॉरमॅट सपोर्ट होत नाही. कृपया JPG, PNG किंवा WEBP फोटो निवडा.",
  [LangKeys.photo_upload_failed]: "फोटो अपलोड अयशस्वी",
  [LangKeys.update_failed]: "अपडेट अयशस्वी",
  [LangKeys.amount]: "रक्कम",
  [LangKeys.photo_max]: "फोटो (कमाल 1MB)",
  [LangKeys.change_photo]: "फोटो बदला",
  [LangKeys.add_entry_title]: "नोंद जोडा",
  [LangKeys.save_entry]: "नोंद सेव्ह करा",
  [LangKeys.photo]: "फोटो",
  [LangKeys.amount_hint]: "₹ 0",
  [LangKeys.note_hint]: "पर्यायी टीप",
  [LangKeys.add_photo_label]: "📷 फोटो जोडा",
  [LangKeys.failed_to_add_entry]: "नोंद जोडण्यात अयशस्वी.",
  [LangKeys.image_too_large_4mb]: "प्रतिमा खूप मोठी आहे. कृपया 4MB पेक्षा कमी असलेली प्रतिमा निवडा.",
  [LangKeys.share_coming_soon]: "शेअर वैशिष्ट्य लवकरच येत आहे!",
  [LangKeys.image_load_failed]: "प्रतिमा लोड करण्यात अयशस्वी",
  [LangKeys.select_date]: "तारीख निवडा",
  [LangKeys.photo_max_2mb]: "फोटो (कमाल 2MB)",
  [LangKeys.add_to_cashbook]: "कॅशबुकमध्येही जोडा",

  // PDF
  [LangKeys.owner_name]: "मालकाचे नाव",
  [LangKeys.customer_ledger_statement]: "ग्राहक खातेवही स्टेटमेंट",
  [LangKeys.phone]: "फोन",
  [LangKeys.opening_balance]: "सुरुवातीची शिल्लक",
  [LangKeys.closing_balance]: "शेवटची शिल्लक",
  [LangKeys.transaction_details]: "व्यवहार तपशील",
  [LangKeys.particulars]: "तपशील",
  [LangKeys.credit_short]: "क्रे",
  [LangKeys.debit_short]: "डे",
  [LangKeys.generated_by]: "मोक्षपाल खाते द्वारे व्युत्पन्न",
  [LangKeys.my_business]: "माझा व्यवसाय",
  [LangKeys.pdf_generation_error]: "PDF तयार करण्यात त्रुटी",
  [LangKeys.debit_minus]: "डेबिट (-)",
  [LangKeys.credit_plus]: "क्रेडिट (+)",
  [LangKeys.total_paid]: "एकूण भरलेली रक्कम",
  [LangKeys.received]: "प्राप्त झाले",
  [LangKeys.paid]: "भरणा",
  [LangKeys.supplier_name]: "पुरवठादाराचे नाव",
  [LangKeys.supplier_report]: "पुरवठादार अहवाल",
  [LangKeys.supplier_ledger_statement]: "पुरवठादार लेजर स्टेटमेंट",
  [LangKeys.data_not_available_for_pdf]: "PDF साठी डेटा उपलब्ध नाही",

  // ACCOUNT
  [LangKeys.account]: "खाते",
  [LangKeys.add_business]: "व्यवसाय तपशील जोडा",
  [LangKeys.add_owner]: "मालक तपशील जोडा",
  [LangKeys.business]: "व्यवसाय",
  [LangKeys.staff]: "कर्मचारी",
  [LangKeys.items]: "वस्तू",
  [LangKeys.bills]: "बिले",
  [LangKeys.dairy]: "डेअरी",
  [LangKeys.cashbook]: "कॅशबुक",
  [LangKeys.help_support]: "मदत आणि समर्थन",
  [LangKeys.about_app]: "आमच्याबद्दल",
  [LangKeys.invite_friends]: "मित्रांना आमंत्रित करा",
  [LangKeys.privacy_policy]: "गोपनीयता धोरण",
  [LangKeys.disclaimer]: "अस्वीकरण",
  [LangKeys.share_subject]: "📒 मोक्सपाल खाता अॅप",
  [LangKeys.share_message]: "👉 उधार-लेनदेन आणि हिशोब ठेवण्यासाठी मी Moxpal Khata अॅप वापरत आहे. हे खूप सोपे आणि विश्वासार्ह अॅप आहे. 📲 तुम्हीही आत्ताच डाउनलोड करा आणि तुमची खाती सहजपणे व्यवस्थापित करा: https://khata.moxpal.com/app",

  // STAFF
  [LangKeys.staff_details]: "कर्मचारी तपशील",
  [LangKeys.staff_question]: "कर्मचारी म्हणजे काय?",
  [LangKeys.add_staff]: "कर्मचारी जोडा",
  [LangKeys.staff_name]: "कर्मचाऱ्याचे नाव",
  [LangKeys.permissions]: "परवानग्या",
  [LangKeys.stop_staff]: "कर्मचारी थांबवा",
  [LangKeys.stop_staff_desc]: "हा कर्मचारी तुमच्या व्यवसाय डेटामध्ये प्रवेश करू शकणार नाही.",
  [LangKeys.delete_staff]: "कर्मचारी हटवा",
  [LangKeys.delete_staff_desc]: "हा कर्मचारी कायमचा हटवला जाईल.",
  [LangKeys.add_staff_to_manage]: "व्यवस्थापनासाठी कर्मचारी जोडा",

  // NAVBAR
  [LangKeys.home]: "होम",
  [LangKeys.more]: "आणखी",

  // ADD PARTY
  [LangKeys.add_party]: "पक्ष जोडा",
  [LangKeys.address_optional]: "पत्ता (पर्यायी)",
  [LangKeys.gst_optional]: "GSTIN (पर्यायी)",
  [LangKeys.add_supplier]: "पुरवठादार जोडा",
  [LangKeys.name_required]: "नाव आवश्यक आहे",
  [LangKeys.edit]: "संपादित करा",

  // BOOK PROFILE
  [LangKeys.book_profile]: "खाते प्रोफाइल बनवा",
  [LangKeys.personal_info]: "वैयक्तिक माहिती",
  [LangKeys.business_info]: "व्यवसाय माहिती",
  [LangKeys.financial_info]: "आर्थिक माहिती",
  [LangKeys.staff_info]: "कर्मचारी माहिती",
  [LangKeys.name]: "नाव",
  [LangKeys.add_name]: "नाव जोडा",
  [LangKeys.registered_number]: "नोंदणीकृत मोबाईल नंबर",
  [LangKeys.add_mobile]: "मोबाईल नंबर जोडा",
  [LangKeys.business_name]: "व्यवसायाचे नाव",
  [LangKeys.business_address]: "व्यवसायाचा पत्ता",
  [LangKeys.add_address]: "पत्ता जोडा",
  [LangKeys.gstin]: "GSTIN",
  [LangKeys.bank_account]: "बँक खाते",
  [LangKeys.add_details]: "तपशील जोडा",
  [LangKeys.details]: "तपशील",
  [LangKeys.add_photo]: "फोटो जोडा",
  [LangKeys.profile_strength]: "प्रोफाइलची ताकद",
  [LangKeys.customer_profile]: "ग्राहक प्रोफाइल",
  [LangKeys.supplier_profile]: "पुरवठादार प्रोफाइल",
  [LangKeys.address]: "पत्ता",
  [LangKeys.type]: "प्रकार",
  [LangKeys.customer]: "ग्राहक",
  [LangKeys.supplier]: "पुरवठादार",
  [LangKeys.delete_customer]: "ग्राहक हटवा",
  [LangKeys.delete_supplier]: "पुरवठादार हटवा",
  [LangKeys.delete_customer_desc]: "तुम्हाला हा ग्राहक हटवायचा आहे का? यासोबत संबंधित सर्व डेटा हटवला जाईल.",
  [LangKeys.delete_supplier_desc]: "तुम्हाला हा पुरवठादार हटवायचा आहे का? यासोबत संबंधित सर्व डेटा हटवला जाईल.",
  [LangKeys.add_gstin]: "GSTIN जोडा",

  /* ================= SMS SETTINGS ================= */
  [LangKeys.sms_settings]: "SMS सेटिंग्ज",
  [LangKeys.sms_settings_desc]: "या ग्राहकासाठी मेसेज सेटिंग्ज व्यवस्थापित करा",
  [LangKeys.edit_customer_details]: "ग्राहक तपशील संपादित करा",
  [LangKeys.edit_customer_details_desc]: "येथे तुम्ही नाव, मोबाईल, पत्ता आणि GST माहिती बदलू शकता.",

  // PROFILE STRENGTH
  [LangKeys.weak]: "कमकुवत",
  [LangKeys.average]: "सरासरी",
  [LangKeys.good]: "चांगले",
  [LangKeys.strong]: "मजबूत",

  // STAFF & PERMISSIONS
  [LangKeys.save_staff]: "कर्मचारी सेव्ह करा",
  [LangKeys.update_staff]: "कर्मचारी अपडेट करा",
  [LangKeys.cancel]: "रद्द करा",
  [LangKeys.no_staff_found]: "कोणतेही कर्मचारी आढळले नाहीत",
  [LangKeys.active]: "सक्रिय",
  [LangKeys.stopped]: "थांबवले",
  [LangKeys.start]: "सुरू करा",
  [LangKeys.stop]: "थांबवा",
  [LangKeys.view]: "पहा",
  [LangKeys.add]: "जोडा",
  [LangKeys.delete]: "हटवा",
  [LangKeys.mobile_number]: "मोबाईल नंबर",
  [LangKeys.add_staff_title]: "कर्मचारी जोडा",
  [LangKeys.edit_staff_title]: "कर्मचारी संपादित करा",
  [LangKeys.staff_deleted_success]: "कर्मचारी यशस्वीरित्या हटवला",
  [LangKeys.yes]: "होय",
  [LangKeys.no]: "नाही",
  [LangKeys.khatabook_deleted_success]: "खातेपुस्तक यशस्वीरित्या हटवले",
  [LangKeys.something_went_wrong]: "काहीतरी चूक झाली",
  [LangKeys.business_logo]: "व्यवसायाचा लोगो",
  [LangKeys.choose_photo]: "फोटो निवडा",
  [LangKeys.save_logo]: "लोगो सेव्ह करा",
  [LangKeys.upload_error]: "अपलोड त्रुटी",
  [LangKeys.upload_type_err]: "अपलोड प्रकार त्रुटी",
  [LangKeys.enter_name]: "नाव प्रविष्ट करा",
  [LangKeys.enter_mobile]: "मोबाईल प्रविष्ट करा",
  [LangKeys.enter_business]: "व्यवसाय प्रविष्ट करा",
  [LangKeys.enter_address]: "पत्ता प्रविष्ट करा",
  [LangKeys.gstin_details]: "GSTIN तपशील",
  [LangKeys.gstin_number]: "GSTIN नंबर",
  [LangKeys.enter_gstin]: "GSTIN प्रविष्ट करा",
  [LangKeys.gstin_note]: "तुमचा GSTIN तुमचा व्यवसाय सत्यापित करण्यासाठी आणि बीजक तयार करण्यासाठी वापरला जातो.",
  [LangKeys.save_gstin]: "GSTIN सेव्ह करा",
  [LangKeys.bank_details]: "बँक तपशील",
  [LangKeys.bank_name]: "बँकेचे नाव",
  [LangKeys.enter_bank_name]: "बँकेचे नाव प्रविष्ट करा",
  [LangKeys.account_number]: "खाते क्रमांक",
  [LangKeys.enter_account_no]: "खाते क्रमांक प्रविष्ट करा",
  [LangKeys.ifsc_code]: "IFSC कोड",
  [LangKeys.enter_ifsc]: "IFSC कोड प्रविष्ट करा",
  [LangKeys.bank_note]: "तुमचे बँक खाते पेमेंट मिळवण्यासाठी वापरले जाते.",
  [LangKeys.save_bank_details]: "बँक तपशील सेव्ह करा",
  [LangKeys.invalid_bank_details]: "अवैध बँक तपशील",
  [LangKeys.confirm]: "पुष्टी करा",
  [LangKeys.invalid_gstin]: "अवैध GSTIN",
  [LangKeys.failed_to_save]: "सेव्ह करण्यात अयशस्वी",

  // Cashbook
  [LangKeys.cash]: "रोख",
  [LangKeys.online]: "ऑनलाइन",
  [LangKeys.total_balance_cashbook]: "एकूण शिल्लक",
  [LangKeys.today_balance]: "आजची शिल्लक",
  [LangKeys.view_report]: "अहवाल पहा",
  [LangKeys.out_entry]: "बाहेर",
  [LangKeys.in_entry]: "आत",
  [LangKeys.add_first_entry]: "तुमची पहिली नोंद जोडा",
  [LangKeys.attach_bill]: "बिल जोडा",
  [LangKeys.enter_amount]: "रक्कम प्रविष्ट करा",
  [LangKeys.empty_title]: "अद्याप कोणत्याही नोंदी नाहीत",
  [LangKeys.saving]: "सेव्ह करत आहे...",
  [LangKeys.save_failed]: "सेव्ह करण्यात अयशस्वी",
  [LangKeys.server_error]: "सर्व्हर त्रुटी",
  [LangKeys.ok]: "ठीक आहे",
  [LangKeys.error]: "त्रुटी",
  [LangKeys.payment_mode]: "पेमेंट मोड",
  [LangKeys.entry_saved_offline_and_will_be_synced_later]: "एन्ट्री ऑफलाइन सेव झाली आहे. इंटरनेट मिळताच सिंक होईल",
  [LangKeys.entry_waiting_to_be_synced]: "एन्ट्री ऑफलाइन सेव आहे, सिंक बाकी आहे",
  [LangKeys.cash_in]: "जमा केले गेले",
  [LangKeys.cash_out]: "रक्कम काढली गेली",
  [LangKeys.cashbook_status]: "कॅशबुक स्टेटस",
  [LangKeys.real_time_cash_online]: "रिअल-टाइम कॅश आणि ऑनलाइन",

  // NEW Cashbook Specific keys
  [LangKeys.entry_is_backed_up]: "नोंद बॅकअप केली आहे",
  [LangKeys.safe_and_secure]: "100% सुरक्षित आणि संरक्षित",
  [LangKeys.invalid_image_format_cashbook_popup]: "असमर्थित स्वरूप. कृपया JPG, PNG, किंवा WEBP वापरा.",
  [LangKeys.photo_size_error_cashbook_popup]: "फाईल खूप मोठी आहे (कमाल 4MB)",
  [LangKeys.selected_image]: "निवडले",

  // Cashbook Report Screen keys
  [LangKeys.cashbook_report_title]: "कॅशबुक अहवाल",
  [LangKeys.date_range]: "तारीख श्रेणी",
  [LangKeys.single_day]: "एक दिवस",
  [LangKeys.this_week]: "हा आठवडा",
  [LangKeys.this_month]: "हा महिना",
  [LangKeys.last_week]: "मागील आठवडा",
  [LangKeys.last_month]: "मागील महिना",
  [LangKeys.all]: "सर्व",
  [LangKeys.to]: "ते",
  [LangKeys.no_entries_found_period]: "या कालावधीत कोणत्याही नोंदी आढळल्या नाहीत.",
  [LangKeys.daily_balance_short]: "दैनिक शिल्लक",
  [LangKeys.download_pdf]: "PDF डाउनलोड करा",
  [LangKeys.pdf_download_not_implemented]: "PDF डाउनलोड अद्याप लागू केले नाही.",

  // Cashbook Report Day Screen keys
  [LangKeys.daily_details]: "दैनिक तपशील",
  [LangKeys.no_entries_on_this_day]: "या दिवशी कोणत्याही नोंदी नाहीत",
  [LangKeys.add_entries_help]: "त्यांना येथे पाहण्यासाठी नोंदी जोडा.",
  [LangKeys.add_entry_to]: "नोंद जोडा",
  [LangKeys.add_entry]: "नोंद जोडा",
  [LangKeys.could_not_load_report]: "अहवाल लोड करू शकलो नाही.",

  // NEW Entry Details Screen specific keys
  [LangKeys.delete_failed]: "हटवण्यात अयशस्वी",
  [LangKeys.photo_max_4mb]: "फोटो (कमाल 4MB)",
  [LangKeys.entry_of_amount]: "रक्कमेची नोंद ",

  // PDF CASHBOOK REPORT
  [LangKeys.daily_summary]: "दैनिक सारांश",
  [LangKeys.total_in]: "एकूण आत",
  [LangKeys.total_out]: "एकूण बाहेर",
  [LangKeys.no_data_available]: "कोणताही डेटा उपलब्ध नाही",

  // Months (for date formatting)
  [LangKeys.month_1]: "जाने",
  [LangKeys.month_2]: "फेब्रु",
  [LangKeys.month_3]: "मार्च",
  [LangKeys.month_4]: "एप्रिल",
  [LangKeys.month_5]: "मे",
  [LangKeys.month_6]: "जून",
  [LangKeys.month_7]: "जुलै",
  [LangKeys.month_8]: "ऑग",
  [LangKeys.month_9]: "सप्टें",
  [LangKeys.month_10]: "ऑक्टो",
  [LangKeys.month_11]: "नोव्हें",
  [LangKeys.month_12]: "डिसें",

  // NEW Customer Supplier Add
  [LangKeys.add_customer]: "ग्राहक जोडा",
  [LangKeys.customer_already_exists]: "ग्राहक आधीच अस्तित्वात आहे",
  [LangKeys.supplier_already_exists]: "पुरवठादार आधीच अस्तित्वात आहे",

  // ✅ NEW CASHBOOK EMPTY STATE
  [LangKeys.cashbook_welcome]: "नमस्कार! चला आजच्या नोंदी करूया",
  [LangKeys.add_first_entry_btn]: "तुमची पहिली नोंद जोडा",

  // ✅ NEW KEY FOR EMPTY STATE TEXT
  [LangKeys.add_customers_collect_faster]: "ग्राहक जोडा आणि पेमेंट जलद गोळा करा",

  // ✅ NEW KEYS FOR PERMISSIONS
  [LangKeys.permission_denied_title]: "परवानगी नाकारली",
  [LangKeys.permission_denied_content]: "फोटो ऍक्सेस कायमस्वरूपी नाकारला आहे. कृपया ऍप सेटिंग्समध्ये जाऊन तो सक्षम करा.",
  [LangKeys.permission_denied_settings_button]: "सेटिंग्स उघडा",
  [LangKeys.permission_denied_cancel_button]: "रद्द करा",
  [LangKeys.permission_denied_generic_message]: "परवानगी नाकारली आहे. फोटो निवडण्यासाठी कृपया फोटो ऍक्सेसला परवानगी द्या.",

  // ✅ Contact Picker
  [LangKeys.permission_required]: "परवानगी आवश्यक आहे",
  [LangKeys.contacts_permission_message]: "Contact निवडण्यासाठी Contacts परवानगी आवश्यक आहे. कृपया अ‍ॅप सेटिंग्समध्ये ती सक्षम करा.",
  [LangKeys.failed_to_open_contacts_picker]: "Contacts picker उघडण्यात अयशस्वी.",
  [LangKeys.permission_denied_to_read_contacts]: "Contacts वाचण्याची परवानगी नाकारली आहे.",

  // ================= ADD ITEM SCREEN =================
  [LangKeys.tax_exempted]: "करमुक्त",
  [LangKeys.no_gst]: "GST लागू नाही",
  [LangKeys.select_photo]: "फोटो निवडा",
  [LangKeys.gallery]: "गॅलरी",
  [LangKeys.camera]: "कॅमेरा",
  [LangKeys.please_enter_item_name]: "कृपया आयटमचे नाव टाका",
  [LangKeys.failed_to_upload_image]: "इमेज अपलोड करण्यात अयशस्वी",
  [LangKeys.item_updated_successfully]: "आयटम यशस्वीपणे अपडेट झाला",
  [LangKeys.item_saved_successfully]: "आयटम यशस्वीपणे सेव्ह झाला",
  [LangKeys.failed_to_update_item]: "आयटम अपडेट करण्यात अयशस्वी",
  [LangKeys.failed_to_save_item]: "आयटम सेव्ह करण्यात अयशस्वी",
  [LangKeys.confirm_deletion]: "डिलीटची खात्री",
  [LangKeys.are_you_sure_delete_item]: "तुम्हाला हा आयटम डिलीट करायचा आहे का?",
  [LangKeys.item_deleted_successfully]: "आयटम यशस्वीपणे डिलीट झाला",
  [LangKeys.failed_to_delete_item]: "आयटम डिलीट करण्यात अयशस्वी",
  [LangKeys.edit_item]: "आयटम एडिट करा",
  [LangKeys.edit_service]: "सेवा एडिट करा",
  [LangKeys.add_product]: "प्रॉडक्ट जोडा",
  [LangKeys.add_service]: "सेवा जोडा",
  [LangKeys.add_hsn_and_gst_details]: "HSN आणि GST माहिती जोडा",
  [LangKeys.hsn]: "HSN",
  [LangKeys.enter_hsn]: "HSN टाका",
  [LangKeys.gst_rate_percent]: "GST दर (%)",
  [LangKeys.enter_gst_rate]: "GST दर टाका",
  [LangKeys.primary_unit]: "मुख्य युनिट",
  [LangKeys.enter_item_name_here]: "इथे आयटमचे नाव लिहा",
  [LangKeys.sale_price]: "विक्री किंमत",
  [LangKeys.purchase_price]: "खरेदी किंमत",
  [LangKeys.tax_included]: "कर समाविष्ट आहे",
  [LangKeys.opening_stock]: "सुरुवातीचा स्टॉक",
  [LangKeys.low_stock_alert]: "कमी स्टॉक सूचना",
  [LangKeys.as_of_date]: "या तारखेपर्यंत",
  [LangKeys.enter_price]: "किंमत टाका",
  [LangKeys.enter_count]: "संख्या टाका",
  [LangKeys.save_item]: "आयटम सेव्ह करा",
  [LangKeys.delete_item]: "आयटम डिलीट करा",
  [LangKeys.select_unit]: "युनिट निवडा",
  [LangKeys.search_unit]: "युनिट शोधा",
  [LangKeys.add_gst_rate]: "GST दर जोडा",
  [LangKeys.add_custom_tax]: "कस्टम कर जोडा",
  [LangKeys.custom_tax]: "कस्टम कर",
  [LangKeys.gst]: "GST",
  [LangKeys.cess]: "सेस",
  [LangKeys.add_hsn_code]: "HSN कोड जोडा",
  [LangKeys.hsn_code]: "HSN कोड",
  [LangKeys.item_name]: "आयटमचे नाव",
  [LangKeys.enter_hsn_code]: "HSN कोड टाका",
  [LangKeys.enter_item_name]: "आयटमचे नाव टाका",
  [LangKeys.results]: "परिणाम",
  [LangKeys.no_hsn_code_found]: "कोणताही HSN कोड आढळला नाही",
  [LangKeys.use]: "वापरा",
  [LangKeys.as_hsn_code]: "HSN कोड म्हणून",
  [LangKeys.you_are_offline_please_connect_to_the_internet]: "तुम्ही ऑफलाइन आहात. कृपया इंटरनेटशी कनेक्ट करा.",

  // ================= ITEMS SCREEN =================
  [LangKeys.products]: "प्रॉडक्ट्स",
  [LangKeys.services]: "सेवा",
  [LangKeys.add_product_caps]: "प्रॉडक्ट जोडा",
  [LangKeys.add_service_caps]: "सेवा जोडा",
  [LangKeys.add_items_and_get_started]: "तुमचे इन्व्हेंटरी व्यवस्थापन सुरू करा",
  [LangKeys.manage_stock_feature]: "तुमच्या व्यवसायासाठी स्मार्ट स्टॉक नियंत्रण",
  [LangKeys.detailed_stock_history_feature]: "आयटम क्रियाकलापांचा संपूर्ण रेकॉर्ड पहा",
  [LangKeys.track_prices_and_profits_feature]: "किंमत आणि नफा मार्जिन सहजपणे मॉनिटर करा",

  [LangKeys.search_items]: "आयटम शोधा",
  [LangKeys.my_items]: "माझे आयटम",
  [LangKeys.item_added]: "आयटम जोडला",
  [LangKeys.low_stock]: "कमी स्टॉक",
  [LangKeys.current_stock]: "सध्याचा स्टॉक",
  [LangKeys.stock_history]: "स्टॉक इतिहास",
  [LangKeys.stock_in]: "स्टॉक इन",
  [LangKeys.stock_out]: "स्टॉक आऊट",
  [LangKeys.add_services_and_get_started]: "तुमच्या सेवांचे व्यवस्थापन सुरू करा",
  [LangKeys.manage_services_feature]: "तुमच्या सर्व सेवा ऑफरिंग्ज व्यवस्थित करा आणि व्यवस्थापित करा",
  [LangKeys.save_sac_and_gst_feature]: "SAC कोड आणि GST तपशील सहज जतन करा",
  [LangKeys.track_sales_and_bills_feature]: "सेवा विक्री आणि बिलिंग नोंदी ट्रॅक करा",

  [LangKeys.net_monthly_sales]: "एकूण मासिक विक्री",
  [LangKeys.rupees]: "रुपये",
  [LangKeys.search_services]: "सेवा शोधा",
  [LangKeys.my_services]: "माझ्या सेवा",
  [LangKeys.service_price]: "सेवेची किंमत",
  [LangKeys.unit]: "युनिट",
  [LangKeys.enter_purchased_quantity]: "खरेदी केलेली मात्रा टाका",
  [LangKeys.enter_sold_quantity]: "विकलेली मात्रा टाका",
  [LangKeys.quantity]: "मात्रा",
  [LangKeys.add_notes_optional]: "नोंद जोडा (ऐच्छिक)",
  [LangKeys.stock_in_caps]: "स्टॉक इन",
  [LangKeys.stock_out_caps]: "स्टॉक आऊट",
  [LangKeys.total_stock]: "एकूण स्टॉक",
  [LangKeys.low_stock_items]: "कमी स्टॉक असलेले आयटम",
  [LangKeys.all_items]: "सर्व आयटम",
  [LangKeys.failed_to_load_items]: "आयटम लोड करण्यात अयशस्वी",



  // ================= ITEMS SALES REPORT SCREEN =================

  [LangKeys.item_sales_report]: "वस्तू विक्री अहवाल",
  [LangKeys.total_qty_sold]: "एकूण विकलेली मात्रा",
  [LangKeys.units]: "युनिट",
  [LangKeys.nos]: "संख्या",
  [LangKeys.sold]: "विकले",
  [LangKeys.bought]: "खरेदी केले",
  [LangKeys.profit]: "नफा",
  [LangKeys.loss]: "तोटा",



  // Filter & Sort
  [LangKeys.filter_by_stock]: "स्टॉकनुसार फिल्टर करा",
  [LangKeys.sort_by_name_az]: "नाव (A–Z) नुसार",
  [LangKeys.sort_by_name_za]: "नाव (Z–A) नुसार",

  // ================= ADD SERVICE SCREEN =================
  [LangKeys.failed_to_process_image]: "इमेज प्रोसेस करण्यात अयशस्वी",
  [LangKeys.could_not_pick_image]: "इमेज निवडता आली नाही",
  [LangKeys.failed_to_upload_photo]: "फोटो अपलोड करण्यात अयशस्वी",
  [LangKeys.failed_to_update_service]: "सेवा अपडेट करण्यात अयशस्वी",
  [LangKeys.failed_to_add_service]: "सेवा जोडण्यात अयशस्वी",
  [LangKeys.are_you_sure_delete_service]: "तुम्हाला ही सेवा डिलीट करायची आहे का?",
  [LangKeys.failed_to_delete_service]: "सेवा डिलीट करण्यात अयशस्वी",
  [LangKeys.add_sac_and_gst_details]: "SAC आणि GST माहिती जोडा",
  [LangKeys.sac_code]: "SAC कोड",
  [LangKeys.enter_sac]: "SAC टाका",
  [LangKeys.enter_service_name_here]: "इथे सेवेचे नाव लिहा",
  [LangKeys.please_enter_service_name]: "कृपया सेवेचे नाव टाका",
  [LangKeys.tax_included_in_price]: "किंमतीत कर समाविष्ट आहे",
  [LangKeys.delete_service]: "सेवा डिलीट करा",
  [LangKeys.save_changes]: "बदल सेव्ह करा",

  // ================= ITEM DETAILS SCREEN =================
  [LangKeys.edit_product]: "प्रॉडक्ट एडिट करा",
  [LangKeys.stock_quantity]: "स्टॉक मात्रा",
  [LangKeys.stock_value]: "स्टॉक किंमत",

  // ================= SERVICE DETAILS SCREEN =================
  [LangKeys.edit_service_caps]: "सेवा एडिट करा",
  [LangKeys.service_name]: "सेवेचे नाव",
  [LangKeys.gst_percent]: "GST %",
  [LangKeys.no_sales_added_for_service]: "या सेवेसाठी कोणतीही विक्री जोडलेली नाही",
  [LangKeys.zero_percent]: "0%",

  /* ================= BILLS SCREEN ================= */
  [LangKeys.bills_add_sale]: "विक्री जोडा",
  [LangKeys.bills_search_sales_hint]: "विक्री शोधा",
  [LangKeys.bills_add_purchase]: "खरेदी जोडा",
  [LangKeys.bills_search_purchases_hint]: "खरेदी शोधा",
  [LangKeys.bills_add_expense]: "खर्च जोडा",
  [LangKeys.bills_search_expenses_hint]: "खर्च शोधा",
  [LangKeys.bills_start_creating_gst]: "GST बिल तयार करायला सुरुवात करा",
  [LangKeys.bills_tab_sale]: "विक्री",
  [LangKeys.bills_tab_purchase]: "खरेदी",
  [LangKeys.bills_tab_expense]: "खर्च",
  [LangKeys.bills_monthly_sales]: "मासिक विक्री",
  [LangKeys.bills_monthly_purchases]: "मासिक खरेदी",
  [LangKeys.bills_view_reports]: "अहवाल पहा",
  [LangKeys.bills_todays_in]: "आजचे येणे",
  [LangKeys.bills_todays_out]: "आजचे जाणे",
  [LangKeys.bills_cashbook]: "कॅशबुक",
  [LangKeys.bills_empty_state_title]: "क्षणात व्यावसायिक इनव्हॉइस तयार करा",
  [LangKeys.bills_empty_state_subtitle]: "लेजर, स्टॉक व कॅशबुक आपोआप अपडेट होतात",
  [LangKeys.bills_empty_state_gst_support]: "GST व Non-GST दोन्ही बिलिंग समर्थित",
  [LangKeys.bills_see_sample_invoices]: "नमुना इनव्हॉइस पहा",
  [LangKeys.bills_no_matching_found]: "जुळणारी बिले सापडली नाहीत",
  [LangKeys.bills_payment_in]: "पेमेंट प्राप्त",
  [LangKeys.bills_status_fully_paid]: "पूर्णपणे भरले",
  [LangKeys.bills_status_unpaid]: "थकबाकी",
  [LangKeys.bills_sale_bill]: "विक्री बिल",
  [LangKeys.bills_purchase_bill]: "खरेदी बिल",
  [LangKeys.bills_expense_bill]: "खर्च",
  [LangKeys.bills_more_button]: "अधिक",
  [LangKeys.bills_added_to_ledger]: "✓ खात्यात जोडले",

  // ================= FILTER & SORT =================
  [LangKeys.filter_and_sort]: "फिल्टर आणि सॉर्ट",
  [LangKeys.filter_by_status]: "स्थितीनुसार फिल्टर करा",
  [LangKeys.filter_all_bills]: "सर्व बिल",
  [LangKeys.filter_paid_bills]: "भरलेली बिल",
  [LangKeys.filter_unpaid_bills]: "बाकी बिल",
  [LangKeys.sort_by]: "क्रमानुसार लावा",
  [LangKeys.sort_latest_first]: "नवीन आधी",
  [LangKeys.sort_oldest_first]: "जुनी आधी",
  [LangKeys.sort_highest_amount]: "सर्वाधिक रक्कम",
  [LangKeys.sort_lowest_amount]: "किमान रक्कम",
  [LangKeys.clear_filters]: "फिल्टर साफ करा",
  [LangKeys.apply_filters]: "फिल्टर लागू करा",

  /* ================= ADD BILL SCREEN ================= */
  [LangKeys.add_bill_sale]: "विक्री",
  [LangKeys.add_bill_purchase]: "खरेदी",
  [LangKeys.add_bill_expense]: "खर्च",
  [LangKeys.add_bill_edit_sale_gst_bill]: "विक्री GST बिल संपादित करा",
  [LangKeys.add_bill_sale_gst_bill]: "विक्री GST बिल",
  [LangKeys.add_bill_edit_purchase_gst_bill]: "खरेदी GST बिल संपादित करा",
  [LangKeys.add_bill_purchase_gst_bill]: "खरेदी GST बिल",
  [LangKeys.add_bill_edit_expense]: "खर्च संपादित करा",
  [LangKeys.add_bill_expense_title]: "खर्च",
  [LangKeys.add_bill_edit_sale_bill]: "विक्री बिल संपादित करा",
  [LangKeys.add_bill_sale_bill]: "विक्री बिल",
  [LangKeys.add_bill_edit_purchase_bill]: "खरेदी बिल संपादित करा",
  [LangKeys.add_bill_purchase_bill]: "खरेदी बिल",
  [LangKeys.add_bill_sale_bill_no]: "विक्री बिल क्रमांक",
  [LangKeys.add_bill_purchase_bill_no]: "खरेदी बिल क्रमांक",
  [LangKeys.add_bill_expense_no]: "खर्च क्रमांक",
  [LangKeys.add_bill_update_sale_bill]: "विक्री बिल अपडेट करा",
  [LangKeys.add_bill_generate_sale_bill]: "विक्री बिल तयार करा",
  [LangKeys.add_bill_update_purchase_bill]: "खरेदी बिल अपडेट करा",
  [LangKeys.add_bill_generate_purchase_bill]: "खरेदी बिल तयार करा",
  [LangKeys.add_bill_update_expense]: "खर्च अपडेट करा",
  [LangKeys.add_bill_generate_expense]: "खर्च जोडा",
  [LangKeys.add_bill_select_customer_error]: "कृपया ग्राहक निवडा",
  [LangKeys.add_bill_add_item_error]: "किमान एक आयटम जोडा",
  [LangKeys.add_bill_updated_successfully]: "यशस्वीपणे अपडेट झाले",
  [LangKeys.add_bill_saved_successfully]: "यशस्वीपणे सेव्ह झाले",
  [LangKeys.add_bill_failed_to_save]: "बिल सेव्ह करण्यात अयशस्वी",
  [LangKeys.add_bill_error_occurred]: "काहीतरी चूक झाली",
  [LangKeys.add_bill_bill_to]: "बिल कोणासाठी",
  [LangKeys.add_bill_search_parties]: "पक्ष शोधा",
  [LangKeys.add_bill_add_new_party]: "नवीन पार्टी जोडा",
  [LangKeys.add_bill_edit_party_details]: "पार्टी तपशील संपादित करा",
  [LangKeys.add_bill_items]: "आयटम्स",
  [LangKeys.add_bill_enter_items_from_inventory]: "स्टॉकमधून आयटम निवडा",
  [LangKeys.add_bill_add_new_item]: "नवीन आयटम जोडा",
  [LangKeys.add_bill_n_items]: "{n} आयटम",
  [LangKeys.add_bill_edit_or_add_items]: "आयटम जोडा किंवा संपादित करा",
  [LangKeys.add_bill_discount]: "सवलत",
  [LangKeys.add_bill_extra_discount]: "अतिरिक्त सवलत",
  [LangKeys.add_bill_item_subtotal]: "आयटम उपएकूण",
  [LangKeys.add_bill_round_off]: "राउंड ऑफ",
  [LangKeys.add_bill_bill_amount]: "बिल रक्कम",
  [LangKeys.add_bill_optional_fields]: "ऐच्छिक फील्ड",
  [LangKeys.add_bill_printed_on_invoice]: "इनव्हॉइसवर छापले जाईल",
  [LangKeys.add_bill_custom_fields]: "सानुकूल फील्ड",
  [LangKeys.add_bill_party_address]: "पार्टीचा पत्ता",
  [LangKeys.add_bill_your_address]: "तुमचा पत्ता",
  [LangKeys.add_bill_terms_conditions]: "अटी व शर्ती",
  [LangKeys.add_bill_private_to_you]: "फक्त तुमच्यासाठी",
  [LangKeys.add_bill_add_notes_photos]: "नोंदी किंवा फोटो जोडा",
  [LangKeys.add_bill_n_photos_added]: "{n} फोटो जोडले",
  [LangKeys.add_bill_balance_due]: "शिल्लक रक्कम",
  [LangKeys.cgst]: "CGST",
  [LangKeys.sgst]: "SGST",
  [LangKeys.pending_bill_no]: "बाकी बिल क्र.",
  [LangKeys.add_bill_add_due_to_ledger]: "लेजरमध्ये बाकी शिल्लक जोडा",
  [LangKeys.add_bill_select_supplier_error]: "कृपया पुरवठादार निवडा",

  /* ================= BILL DETAILS SCREEN ================= */
  [LangKeys.bill_details_error_id_missing]: "बिल आयडी उपलब्ध नाही",
  [LangKeys.bill_details_failed_to_load]: "बिल लोड करण्यात अयशस्वी",
  [LangKeys.bill_details_delete_confirmation_title]: "बिल हटवा",
  [LangKeys.bill_details_delete_confirmation_content]: "तुम्हाला हे बिल हटवायचे आहे का? कृपया लक्षात ठेवा की बिलाशी संबंधित कॅशबुक नोंदही हटवली जाईल.",
  [LangKeys.bill_details_delete_button]: "हटवा",
  [LangKeys.bill_details_deleted_successfully]: "बिल यशस्वीपणे हटवले",
  [LangKeys.bill_details_failed_to_delete]: "बिल हटवण्यात अयशस्वी",
  [LangKeys.bill_details_generating_pdf]: "PDF तयार होत आहे",
  [LangKeys.bill_details_share_text]: "हे तुमचे बिल आहे",
  [LangKeys.bill_details_failed_to_share]: "बिल शेअर करण्यात अयशस्वी",
  [LangKeys.bill_details_title]: "बिल तपशील",
  [LangKeys.bill_details_could_not_load]: "बिल तपशील लोड होऊ शकले नाहीत",
  [LangKeys.bill_details_status]: "स्थिती",
  [LangKeys.bill_details_status_pending]: "प्रलंबित",
  [LangKeys.bill_details_no_items]: "कोणतेही आयटम जोडलेले नाहीत",
  [LangKeys.bill_details_view_pdf]: "PDF पहा",

  /* ================= EXPENSE DETAILS SCREEN ================= */
  [LangKeys.expense_number_prefix]: "खर्च #",
  [LangKeys.edit_expense]: "खर्च संपादित करा",
  [LangKeys.delete_expense]: "खर्च हटवा",
  [LangKeys.deleting_expense]: "हटवले जात आहे...",
  [LangKeys.expense_deleted_successfully]: "खर्च यशस्वीरित्या हटवला गेला",
  [LangKeys.failed_to_delete_expense]: "खर्च हटवण्यात अयशस्वी",
  [LangKeys.edit_feature_coming_soon]: "संपादन सुविधा लवकरच येत आहे!",
  [LangKeys.delete_expense_confirmation]: "तुम्हाला हा खर्च नक्की हटवायचा आहे का?",

  /* ================= INVOICE PREVIEW SCREEN ================= */
  [LangKeys.invoice_preview_title]: "इनव्हॉइस पूर्वावलोकन",
  [LangKeys.invoice_preview_generating]: "इनव्हॉइस तयार होत आहे",
  [LangKeys.invoice_preview_failed]: "इनव्हॉइस तयार करण्यात अयशस्वी",
  [LangKeys.invoice_preview_preparing_print]: "प्रिंटसाठी तयारी",
  [LangKeys.invoice_preview_failed_print]: "प्रिंट अयशस्वी",
  [LangKeys.invoice_preview_delete_title]: "इनव्हॉइस हटवा",
  [LangKeys.invoice_preview_delete_content]: "तुम्हाला हा इनव्हॉइस हटवायचा आहे का? कृपया लक्षात ठेवा की याच्याशी संबंधित कॅशबुक नोंदही हटवली जाईल.",
  [LangKeys.invoice_preview_deleted_successfully]: "इनव्हॉइस हटवला",
  [LangKeys.invoice_preview_failed_delete]: "इनव्हॉइस हटवण्यात अयशस्वी",
  [LangKeys.invoice_preview_theme_premium]: "प्रीमियम",
  [LangKeys.invoice_preview_theme_thermal]: "थर्मल",
  [LangKeys.invoice_preview_theme_basic]: "बेसिक",
  [LangKeys.invoice_preview_theme_new]: "नवीन",
  [LangKeys.invoice_preview_download]: "इनव्हॉइस डाउनलोड करा",
  [LangKeys.invoice_preview_share]: "इनव्हॉइस शेअर करा",
  [LangKeys.invoice_preview_print]: "इनव्हॉइस प्रिंट करा",
  [LangKeys.invoice_preview_create_new]: "नवीन तयार करा",
  [LangKeys.invoice_preview_done]: "पूर्ण",

  /* ================= PAYMENT DETAILS SCREEN ================= */
  [LangKeys.payment_details_title_in]: "पेमेंट प्राप्त",
  [LangKeys.payment_details_title_out]: "पेमेंट दिले",
  [LangKeys.payment_details_share_text]: "पेमेंट तपशील",
  [LangKeys.payment_details_failed_to_share]: "पेमेंट तपशील शेअर करण्यात अयशस्वी",
  [LangKeys.payment_details_adjusted_invoices]: "समायोजित इनव्हॉइस",

  /* ================= SAMPLE INVOICES SCREEN ================= */
  [LangKeys.sample_invoice_title]: "नमुना",
  [LangKeys.premium_invoice]: "प्रीमियम इनव्हॉइस",
  [LangKeys.thermal_invoice]: "थर्मल इनव्हॉइस",
  [LangKeys.basic_invoice]: "बेसिक इनव्हॉइस",
  [LangKeys.use_this_template]: "हा टेम्पलेट वापरा",

  /* ================= ITEM SELECT SHEET ================= */
  [LangKeys.item_select_not_enough_stock]: "पुरेसा साठा उपलब्ध नाही. फक्त {availableStock} उपलब्ध आहे.",
  [LangKeys.item_select_no_items_found]: "कोणतेही आयटम सापडले नाहीत",
  [LangKeys.item_select_item_discount]: "आयटम सवलत",
  [LangKeys.item_select_final_price]: "अंतिम किंमत",
  [LangKeys.item_select_gst_rate]: "GST दर",
  [LangKeys.item_select_item_single]: "आयटम",
  [LangKeys.item_select_item_plural]: "आयटम्स",
  [LangKeys.item_select_continue]: "पुढे जा",
  [LangKeys.item_select_add_items_to_invoice]: "इनव्हॉइसमध्ये आयटम जोडा",
  [LangKeys.item_select_search_created_items]: "तयार केलेले आयटम शोधा",
  [LangKeys.item_select_add_new]: "नवीन जोडा",

  /* ================= QUICK ADD ITEM DIALOG ================= */
  [LangKeys.add_more_details]: "अधिक तपशील जोडा (स्टॉक, खरेदी किंमत इ.)",
  [LangKeys.add_item_to_bill]: "बिलमध्ये आयटम जोडा",
  [LangKeys.please_enter_value]: "कृपया मूल्य प्रविष्ट करा",
  [LangKeys.please_enter_valid_number]: "कृपया वैध संख्या प्रविष्ट करा",

  /* ================= CUSTOM FIELDS DIALOG ================= */
  [LangKeys.add_bill_custom_fields_subtitle]:
    "जास्तीत जास्त 5 सानुकूल फील्ड जोडा (उदा. सिरियल नंबर, बॅच, IMEI इ.)",
  [LangKeys.add_bill_add_new_custom_field]: "नवीन सानुकूल फील्ड जोडा",
  [LangKeys.add_bill_max_custom_fields]: "तुम्ही जास्तीत जास्त 5 सानुकूल फील्ड जोडू शकता.",
  [LangKeys.add_bill_custom_field_name_hint]: "फील्ड नाव",
  [LangKeys.add_bill_custom_field_value_hint]: "मूल्य",

  /* ================= EDIT PRICE DIALOG ================= */
  [LangKeys.edit_price_gst_details]: "({cgst}% CGST + {sgst}% SGST; {igst}% IGST)",
  [LangKeys.edit_price_enter_discount_hint]: "सवलत प्रविष्ट करा",
  [LangKeys.rupee]: "रुपया",
  [LangKeys.percentage]: "टक्केवारी",
  [LangKeys.rate]: "दर",
  [LangKeys.tax]: "कर",

  /* ================= ADDRESS SCREEN ================= */
  [LangKeys.address_business_address_title]: "व्यवसायाचा पत्ता",
  [LangKeys.address_flat_building_number]: "फ्लॅट / इमारत क्रमांक",
  [LangKeys.address_enter_flat_building_number]: "कृपया फ्लॅट / इमारत क्रमांक प्रविष्ट करा",
  [LangKeys.address_area_locality]: "परिसर / भाग",
  [LangKeys.address_enter_area_locality]: "कृपया परिसर / भाग प्रविष्ट करा",
  [LangKeys.address_city]: "शहर",
  [LangKeys.address_enter_city]: "कृपया शहर प्रविष्ट करा",
  [LangKeys.address_state]: "राज्य",
  [LangKeys.address_enter_state]: "कृपया राज्य प्रविष्ट करा",
  [LangKeys.address_pincode]: "पिनकोड",
  [LangKeys.address_enter_pincode]: "कृपया पिनकोड प्रविष्ट करा",
  [LangKeys.address_invalid_pincode]: "अवैध पिनकोड",

  /* ================= PARTY ADDRESS SCREEN ================= */
  [LangKeys.party_address_title]: "ग्राहकाचा पत्ता",
  [LangKeys.party_address_billing_address]: "बिलिंग पत्ता",
  [LangKeys.party_address_shipping_same_as_billing]: "शिपिंग पत्ता बिलिंगसारखाच",

  /* ================= ADD NOTES AND PHOTOS DIALOG ================= */
  [LangKeys.add_notes_and_photos_title]: "नोंदी व फोटो जोडा",
  [LangKeys.add_notes_and_photos_subtitle]: "अतिरिक्त तपशील किंवा प्रतिमा जोडा",
  [LangKeys.add_notes_and_photos_notes_hint]: "येथे नोंदी लिहा",
  [LangKeys.photos_access_permanently_denied]: "फोटो प्रवेश कायमस्वरूपी नाकारला आहे. कृपया अॅप सेटिंगमध्ये जाऊन परवानगी सक्षम करा.",
  [LangKeys.photos_access_denied]: "फोटो निवडण्यासाठी कृपया डिव्हाइस सेटिंगमध्ये कॅमेरा किंवा फोटो प्रवेशाची परवानगी द्या.",
  [LangKeys.open_settings]: "सेटिंग उघडा",

  /* ================= TERMS AND CONDITIONS DIALOG ================= */
  [LangKeys.terms_and_conditions_title]: "अटी व शर्ती",
  [LangKeys.terms_and_conditions_hint]: "अटी व शर्ती प्रविष्ट करा",

  // ================= KHATA TABS =================
  [LangKeys.customers]: "ग्राहक",
  [LangKeys.suppliers]: "पुरवठादार",
  [LangKeys.search_supplier]: "पुरवठादार शोधा",
  [LangKeys.add_first_customer]: "तुमचा पहिला ग्राहक जोडा",
  [LangKeys.add_first_supplier]: "तुमचा पहिला पुरवठादार जोडा",
  [LangKeys.add_new_customer_prompt]: "आतापर्यंत कोणताही ग्राहक जोडलेला नाही. नवीन ग्राहक जोडण्यासाठी वर दिलेल्या “+” बटणावर टॅप करा.",
  [LangKeys.add_new_suppliers_prompt]: "आतापर्यंत कोणताही पुरवठादार जोडलेला नाही. नवीन पुरवठादार जोडण्यासाठी वर दिलेल्या “+” बटणावर टॅप करा.",

  // ================= CASHBOOK HELP DIALOG =================
  [LangKeys.cashbook_help_title]: "कॅशबुक मदत",
  [LangKeys.cashbook_help_in_title]: "कॅश इन (जमा)",
  [LangKeys.cashbook_help_in_desc]: "येथे तुमच्या व्यवसायात प्राप्त झालेल्या सर्व रोख नोंदींचा तपशील दर्शविला जातो.",
  [LangKeys.cashbook_help_out_title]: "कॅश आउट (निघती)",
  [LangKeys.cashbook_help_out_desc]: "येथे तुमच्या व्यवसायातून खर्च झालेल्या सर्व रोख नोंदींचा तपशील दर्शविला जातो.",
  [LangKeys.cashbook_help_total_balance_title]: "एकूण शिल्लक",
  [LangKeys.cashbook_help_total_balance_desc]: "हे तुमच्या कॅशबुकची सध्याची एकूण शिल्लक दर्शवते.",
  [LangKeys.cashbook_help_today_balance_title]: "आजची शिल्लक",
  [LangKeys.cashbook_help_today_balance_desc]: "हे फक्त आजच्या रोख व्यवहारांच्या आधारे शिल्लक दर्शवते.",
  [LangKeys.cashbook_help_report_title]: "कॅशबुक अहवाल",
  [LangKeys.cashbook_help_report_desc]: "येथून तुम्ही कॅशबुक अहवाल पाहू आणि डाउनलोड करू शकता.",

  // ✅ NEW KEYS FOR ADD EXPENSE SCREEN
  [LangKeys.expense_amount]: "खर्चाची रक्कम",
  [LangKeys.select_category]: "श्रेणी निवडा",
  [LangKeys.select_expense_category]: "खर्चाची श्रेणी निवडा",
  [LangKeys.expense_items_warning]: "खर्चाच्या वस्तू तुमच्या इन्व्हेंटरी वस्तूंवर परिणाम करणार नाहीत.",
  [LangKeys.add_expense_items_optional]: "खर्चाच्या वस्तू जोडा (पर्यायी)",
  [LangKeys.expense_items_feature_coming_soon]: "खर्च वस्तू सुविधा लवकरच येत आहे!",
  [LangKeys.notes_and_photos_optional]: "नोट्स आणि फोटो (पर्यायी)",
  [LangKeys.photos_added]: "फोटो जोडले गेले",
  [LangKeys.save_expense_amount]: "खर्च जतन करा",
  [LangKeys.update_expense_amount]: "खर्च अपडेट करा",
  [LangKeys.expense_saved_successfully]: "खर्च यशस्वीरित्या जतन झाला",
  [LangKeys.expense_updated_successfully]: "खर्च यशस्वीरित्या अपडेट झाला",
  [LangKeys.failed_to_save_expense]: "खर्च जतन करण्यात अयशस्वी",
  [LangKeys.enter_valid_amount]: "कृपया योग्य रक्कम प्रविष्ट करा.",
  [LangKeys.please_select_expense_category]: "कृपया खर्चाची श्रेणी निवडा.",
  [LangKeys.category]: "श्रेणी",

  // ===== EXPENSE CATEGORIES =====
  [LangKeys.cat_rent]: "भाडे",
  [LangKeys.cat_salaries]: "पगार / मजुरी",
  [LangKeys.cat_electricity]: "वीज",
  [LangKeys.cat_water]: "पाण्याचे बिल",
  [LangKeys.cat_internet]: "दूरध्वनी / इंटरनेट",
  [LangKeys.cat_office]: "कार्यालयीन खर्च",
  [LangKeys.cat_marketing]: "मार्केटिंग / जाहिरात",
  [LangKeys.cat_travel]: "प्रवास",
  [LangKeys.cat_fuel]: "इंधन / पेट्रोल",
  [LangKeys.cat_food]: "अन्न / अल्पोपहार",
  [LangKeys.cat_repairs]: "दुरुस्ती व देखभाल",
  [LangKeys.cat_election]: "निवडणूक खर्च",
  [LangKeys.cat_taxes]: "कर / जीएसटी",
  [LangKeys.cat_insurance]: "विमा",
  [LangKeys.cat_cleaning]: "स्वच्छता",
  [LangKeys.cat_delivery]: "डिलिव्हरी / शिपिंग",
  [LangKeys.cat_software]: "सॉफ्टवेअर / अॅप्स",
  [LangKeys.cat_furniture]: "फर्निचर",
  [LangKeys.cat_other]: "इतर",

  // ================= EXPENSE EMPTY STATE =================
  [LangKeys.expense_empty_title]: "तुमचे खर्च सहज व्यवस्थापित करा",
  [LangKeys.expense_empty_subtitle]: "तुमच्या व्यवसायाचे सर्व खर्च एका ठिकाणी ट्रॅक करा.",
  [LangKeys.expense_empty_footer]: "सर्व खर्च आपोआप कॅशबुकमध्ये जोडले जातात.",

  // ================= BILL REPORT SCREEN =================
  [LangKeys.bill_report_title]: "बिल अहवाल",
  [LangKeys.report_for_period]: "या कालावधीसाठी अहवाल",
  [LangKeys.select_date_range]: "तारीख श्रेणी निवडा",
  [LangKeys.total_sales]: "एकूण विक्री",
  [LangKeys.total_purchases]: "एकूण खरेदी",
  [LangKeys.total_expenses]: "एकूण खर्च",
  [LangKeys.net_profit]: "निव्वळ नफा",
  [LangKeys.net_loss]: "निव्वळ तोटा",
  [LangKeys.all_transactions]: "सर्व व्यवहार",
  [LangKeys.no_transactions_found_period]: "या कालावधीत कोणतेही व्यवहार आढळले नाहीत",
  [LangKeys.expense_fallback_category]: "इतर खर्च",

  // ================= SALES REPORT SCREEN =================
  [LangKeys.sales_report]: "विक्री अहवाल",
  [LangKeys.transactions]: "व्यवहार",
  [LangKeys.net_sale]: "निव्वळ विक्री",
  [LangKeys.unpaid_balance]: "बाकी रक्कम",
  [LangKeys.sales_report_share_text]: "हा तुमच्या विक्री अहवालाचा सारांश आहे.",

  // ================= PURCHASE REPORT SCREEN =================
  [LangKeys.purchase_report]: "खरेदी अहवाल",
  [LangKeys.net_purchase]: "निव्वळ खरेदी",
  [LangKeys.purchase_report_share_text]: "हा तुमच्या खरेदी अहवालाचा सारांश आहे.",

  // ================= KHATA FILTER & SORT =================
  [LangKeys.filter_by_balance]: "शिल्लक रकमेप्रमाणे फिल्टर करा",
  [LangKeys.filter_all_parties]: "सर्व पक्ष",

  // ================= LOGOUT =================
  [LangKeys.logout_confirm]: "तुम्हाला खात्री आहे का की तुम्ही लॉगआउट करू इच्छिता?",
  [LangKeys.confirm_logout]: "लॉगआउट",

  // ================= DEVICES =================
  [LangKeys.manage_devices]: "डिव्हाइस व्यवस्थापित करा",
  [LangKeys.active_devices]: "सक्रिय डिव्हाइस",
  [LangKeys.logout_device]: "डिव्हाइस लॉगआउट",
  [LangKeys.logout_device_confirm]: "तुम्ही हे डिव्हाइस लॉगआउट करू इच्छिता का?",
  [LangKeys.device_logged_out]: "डिव्हाइस यशस्वीरित्या लॉगआउट झाले",
  [LangKeys.no_active_devices]: "कोणतेही सक्रिय डिव्हाइस नाही",
  [LangKeys.last_login]: "शेवटचा लॉगिन",
  [LangKeys.this_device]: "हे डिव्हाइस",
  [LangKeys.loading_devices]: "डिव्हाइस लोड होत आहेत...",

  /* ================= SMS SETTINGS ================= */
  [LangKeys.send_whatsapp_messages]: "Whatsapp संदेश पाठवणे",
  [LangKeys.enabled]: "चालू",
  [LangKeys.disabled]: "बंद",
  [LangKeys.manage_whatsapp_settings]: "Whatsapp SMS सेटिंग्ज व्यवस्थापित करा",
  [LangKeys.recharge_and_control]: "क्रेडिट रिचार्ज करा आणि संदेश नियंत्रित करा",

  [LangKeys.wa_message_failed]: "संदेश पाठवण्यात अयशस्वी",
  [LangKeys.wa_no_credits]: "क्रेडिट संपले आहेत, संदेश पाठवला गेला नाही",

  // DASHBOARD EMPTY STATE
  [LangKeys.pro_tip]: "प्रो टिप",
  [LangKeys.dashboard_empty_tip]: "पूर्ण तपशील पाहण्यासाठी, संपादित करण्यासाठी किंवा ग्राहकांसोबत शेअर करण्यासाठी डाव्या बाजूच्या कोणत्याही एंट्रीवर क्लिक करा.",
  [LangKeys.select_entry]: "एंट्री निवडा",
  [LangKeys.entry_details_appear]: "एंट्रीचे तपशील येथे दिसतील",

  // REPORTS DASHBOARD
  [LangKeys.business_reports]: "व्यावसायिक अहवाल",
  [LangKeys.business_reports_desc]: "तुमच्या व्यवसायासाठी विश्लेषण आणि अंतर्दृष्टी",
  [LangKeys.ledger_cashbook_reports]: "बहीखाता आणि कॅशबुक अहवाल",
  [LangKeys.billing_inventory_reports]: "बिलिंग आणि इन्व्हेंटरी अहवाल",
  [LangKeys.customer_ledger_statement_report]: "ग्राहक बहीखाता विवरण",
  [LangKeys.customer_ledger_report_desc]: "सर्व ग्राहकांसाठी तपशीलवार बहीखाता आणि व्यवहार इतिहास",
  [LangKeys.supplier_ledger_statement_report]: "सप्लायर बहीखाता विवरण",
  [LangKeys.supplier_ledger_report_desc]: "सर्व सप्लायर्ससाठी तपशीलवार बहीखाता आणि व्यवहार इतिहास",
  [LangKeys.cashbook_report_desc]: "रोख आणि ऑनलाइन नोंदींसाठी दैनिक विवरण",
  [LangKeys.sales_report_desc]: "बिल-निहाय विक्री सारांश, एकूण विक्री आणि बाकी रक्कम",
  [LangKeys.purchase_report_desc]: "बिल-निहाय खरेदी नोंदी आणि सारांश",
  [LangKeys.bills_summary_report]: "बिल सारांश अहवाल",
  [LangKeys.bills_summary_report_desc]: "विक्री, खरेदी आणि नफा/तोटा गणनांचे विहंगावलोकन",
  [LangKeys.item_stock_sales_report]: "आइटम स्टॉक आणि विक्री अहवाल",
  [LangKeys.item_stock_sales_report_desc]: "उत्पादने आणि सेवांच्या स्टॉक आणि विक्रीचा सारांश",
  [LangKeys.select_party]: "पार्टी निवडा",
  [LangKeys.search_placeholder]: "नाव किंवा मोबाईल नंबरने शोधा...",
  [LangKeys.back_to_dashboard]: "अहवाल मेनूवर परत जा",
  [LangKeys.loading_report_data]: "अहवाल डेटा लोड होत आहे...",
  [LangKeys.no_parties_found]: "कोणतीही पार्टी आढळली नाही.",
  [LangKeys.select_customer]: "अहवाल पाहण्यासाठी ग्राहक निवडा",
  [LangKeys.select_supplier]: "अहवाल पाहण्यासाठी सप्लायर निवडा",
  [LangKeys.premium_feature]: "प्रीमियम फीचर",
  [LangKeys.premium_lock_desc]: "व्यावसायिक बिलिंग, विक्री/खरेदी बीजक अहवाल, डेबुक स्टेटमेंट आणि इन्व्हेंटरी सारांश अनलॉक करा.",
  [LangKeys.upgrade_to_premium]: "जाहिरात मुक्त+ / प्रीमियम वर अपग्रेड करा 🚀",
  // PREMIUM
  [LangKeys.plan_standard_name]: "स्टँडर्ड (जाहिरात-मुक्त)",
  [LangKeys.plan_ads_free_name]: "जाहिरात-मुक्त +",
  [LangKeys.plan_premium_name]: "प्रीमियम",
  [LangKeys.plan_recommended_tag]: "शिफारस केलेला प्लॅन",
  [LangKeys.plan_duration_30_days]: "30 दिवसांसाठी",
  [LangKeys.plan_duration_180_days]: "180 दिवसांसाठी (6 महिने)",
  [LangKeys.plan_duration_365_days]: "365 दिवसांसाठी (1 वर्ष)",
  [LangKeys.plan_duration_30_days_badge]: "30 दिवस",
  [LangKeys.plan_save_20_percent]: "बचत ~20%",
  [LangKeys.plan_best_value_badge]: "सर्वोत्तम मूल्य",
  [LangKeys.plan_best_value_plan_tag]: "सर्वोत्तम मूल्य प्लॅन",
  [LangKeys.plan_most_popular_save]: "सर्वात लोकप्रिय • ₹{amount} बचत",
  [LangKeys.plan_save_amount_tag]: "₹{amount} बचत",
  [LangKeys.duration_1_month]: "1 महिना",
  [LangKeys.duration_6_months]: "6 महिने",
  [LangKeys.duration_12_months]: "12 महिने",
  [LangKeys.plan_save_text]: "बचत करा",
  [LangKeys.benefit_no_ads]: "जाहिराती नाहीत (100% जाहिरात-मुक्त अनुभव)",
  [LangKeys.benefit_support]: "24/7 प्राधान्य ग्राहक सहाय्य",
  [LangKeys.benefit_all_ads_free]: "Ads Free + प्लॅनचे सर्व फायदे",
  [LangKeys.benefit_multiple_devices]: "एकाच वेळी अनेक उपकरणांवर लॉगिन करा",
  [LangKeys.benefit_desktop_access]: "कंप्युटर/डेस्कटॉपवर प्रवेश",
  [LangKeys.benefit_create_bills]: "बिल तयार करा (सामान्य बिल, GST बिल)",
  [LangKeys.benefit_defaulters_list]: "एका क्लिकमध्ये थकबाकीदारांची यादी पहा",
  [LangKeys.benefit_organize_lists]: "यादींसह तुमची खाती व्यवस्थित करा",
  [LangKeys.benefit_manage_stocks]: "स्टॉक्स व्यवस्थापित करा (व्यवहारांसह आयटम जोडा)",
  [LangKeys.benefit_financial_reports]: "प्रीमियम आर्थिक अहवाल (PDF/Excel)",
  [LangKeys.benefit_dual_backup]: "सुरक्षित लोकल आणि क्लाऊड स्टोरेजवर दुहेरी बॅकअप",
  [LangKeys.benefit_unlimited_entry]: "कॅशबुक/खात्यामध्ये अमर्याद नोंदी",
  [LangKeys.benefit_unlimited_transactions]: "अमर्याद व्यवहार (Unlimited Transactions)",
  [LangKeys.benefit_unlimited_sms]: "अमर्याद SMS",
  [LangKeys.benefit_dairy_management]: "डेअरी सुविधा (दुधाचे रेकॉर्ड, दर तक्ते, बिले)",
  [LangKeys.benefit_refer_earn]: "रेफर करा आणि कमवा (मोफत रिचार्जची वैधता)",
  [LangKeys.my_subscription_title]: "माझी सदस्यता",
  [LangKeys.premium_plans_title]: "आमचे प्रीमियम प्लॅन्स",
  [LangKeys.active_badge_label]: "सक्रिय",
  [LangKeys.expires_on_label]: "मुदत {date} ला संपेल",
  [LangKeys.expired_badge_label]: "कालबाह्य",
  [LangKeys.expired_on_label]: "{date} रोजी कालबाह्य झाले",
  [LangKeys.extend_plan_label]: "प्लॅन वाढवा (+{days} दिवस)",
  [LangKeys.days_remaining_label]: "({days} दिवस शिल्लक)",
  [LangKeys.secure_checkout_label]: "100% सुरक्षित SSL पेमेंट",
  [LangKeys.upgrade_button]: "अपग्रेड करा",
  [LangKeys.downgrade_button]: "डाऊनग्रेड करा",

  // Business Profile & Marketplace
  [LangKeys.biz_profile__marketplace_settings]: 'ऑनलाइन स्टोअर सेटिंग्स (Moxpal Market)',
  [LangKeys.biz_profile__online_business_toggle]: 'ऑनलाइन बिझनेस सुरू ठेवा',
  [LangKeys.biz_profile__online_business_active]: 'बिझनेस ऑनलाइन सक्रिय आहे (Active)',
  [LangKeys.biz_profile__online_business_offline]: 'बिझनेस ऑनलाइन बंद आहे (Offline)',
  [LangKeys.biz_profile__gps_pending_badge]: 'ऑनलाइन सुरू आहे (GPS सेट करा)',
  [LangKeys.biz_profile__online_business_sub_active]: 'सुरू केल्यानंतर 1-क्लिकमध्ये राज्य, जिल्हा, परिसर आणि पिनकोड भरा आणि GPS लोकेशन सेट करा जेणेकरून दुकान ग्राहकांना दिसेल.',
  [LangKeys.biz_profile__online_business_sub_offline]: 'बिझनेस ऑनलाइन सुरू करा जेणेकरून स्थानिक ग्राहक तुमची उत्पादने आणि सेवा शोधू शकतील.',
  [LangKeys.biz_profile__know_benefits_btn]: '💡 याचे फायदे आणि नियम जाणून घ्या',
  [LangKeys.biz_profile__benefits_modal_title]: 'ऑनलाइन बिझनेसचे फायदे आणि संपूर्ण माहिती',
  [LangKeys.biz_profile__benefits_step1_title]: '1. हे सुरू केल्याने काय होईल?',
  [LangKeys.biz_profile__benefits_step1_desc]: 'तुमचा व्यवसाय, उत्पादने आणि सेवा त्वरित लोकल मार्केटमध्ये लाईव्ह होतील. परिसरातील सर्व ग्राहक तुमच्याशी थेट संपर्क साधू शकतील.',
  [LangKeys.biz_profile__benefits_step2_title]: '2. तुम्हाला काय करावे लागेल?',
  [LangKeys.biz_profile__benefits_step2_desc]: '• निळ्या बटनाने (⚡ 1-क्लिक) राज्य, जिल्हा, परिसर, पिनकोड आणि GPS सेट करा.\n• तुमची उत्पादने किंवा सेवा जोडा.',
  [LangKeys.biz_profile__benefits_step3_title]: '3. याचे काय फायदे मिळतील?',
  [LangKeys.biz_profile__benefits_step3_desc]: '• 0% कमिशन (100% मोफत) — कोणताही मध्यस्थ नाही.\n• थेट WhatsApp आणि कॉलवर ग्राहकांकडून ऑर्डर्स मिळवा.\n• 24 तास सुरू असणारे डिजिटल दुकान.',
  [LangKeys.biz_profile__benefits_btn_got_it]: 'समजले, धन्यवाद 👍',
  [LangKeys.biz_profile__autofill_btn_title]: '⚡ 1-क्लिकमध्ये पूर्ण पत्ता ऑटो भरा',
  [LangKeys.biz_profile__autofill_btn_sub]: 'GPS ने राज्य, जिल्हा, गाव आणि पिनकोड आपोआप भरा',
  [LangKeys.biz_profile__autofill_searching]: 'लोकेशन शोधत आहे...',
  [LangKeys.biz_profile__state_lbl]: 'राज्य (State)',
  [LangKeys.biz_profile__state_add]: 'राज्य जोडा',
  [LangKeys.biz_profile__state_placeholder]: 'उदा. Maharashtra, Gujarat...',
  [LangKeys.biz_profile__city_lbl]: 'शहर / जिल्हा (City / District)',
  [LangKeys.biz_profile__city_add]: 'शहर जोडा',
  [LangKeys.biz_profile__city_placeholder]: 'उदा. Mumbai, Pune, Nagpur...',
  [LangKeys.biz_profile__area_lbl]: 'गाव / परिसर / इलाका (Area / Village)',
  [LangKeys.biz_profile__area_add]: 'गाव/परिसर जोडा',
  [LangKeys.biz_profile__area_placeholder]: 'उदा. Sadashiv Peth, Andheri...',
  [LangKeys.biz_profile__pincode_lbl]: 'पिनकोड (Pincode)',
  [LangKeys.biz_profile__pincode_add]: 'पिनकोड जोडा',
  [LangKeys.biz_profile__pincode_placeholder]: '6 अंकी पिनकोड प्रविष्ट करा',
  [LangKeys.biz_profile__tagline_lbl]: 'व्यवसायाची टॅगलाइन/वर्णन',
  [LangKeys.biz_profile__tagline_add]: 'टॅगलाइन जोडा',
  [LangKeys.biz_profile__tagline_placeholder]: 'उदा. आमच्याकडे ताजी आणि शुद्ध उत्पादने मिळतात',
  [LangKeys.biz_profile__gps_lbl]: 'व्यवसायाचे GPS लोकेशन',
  [LangKeys.biz_profile__gps_not_set]: 'लोकेशन अजून सेट नाही',
  [LangKeys.biz_profile__gps_update_btn]: 'अपडेट करा',
  [LangKeys.biz_profile__gps_get_btn]: 'GPS लोकेशन घ्या',
  [LangKeys.biz_profile__gps_searching]: 'शोधत आहे...',
  [LangKeys.biz_profile__gps_live_warning]: '⚠️ स्टोअर ऑनलाइन आहे पण GPS सेट नाही! कृपया ⚡ 1-क्लिक बटनाने GPS सेट करा जेणेकरून दुकान ग्राहकांना दिसेल.',
  [LangKeys.biz_profile__gps_turn_on_toast]: 'कृपया ब्राउझर/फोनचे GPS लोकेशन चालू करा',
  [LangKeys.biz_profile__gps_permission_denied_toast]: 'लोकेशन परवानगी नाकारली गेली',
  [LangKeys.biz_profile__gps_permission_settings_toast]: 'कृपया ब्राउझर सेटिंग्जमध्ये जाऊन Location Permission चालू करा',
  [LangKeys.biz_profile__gps_autofill_success_toast]: 'GPS द्वारे पूर्ण पत्ता आपोआप भरला गेला!',
  [LangKeys.biz_profile__gps_error_toast]: 'लोकेशन मिळवण्यात त्रुटी',
  [LangKeys.biz_market_video_guide_title]: 'लोकल मार्केटमध्ये दुकान ऑनलाइन कसे करावे?',
  [LangKeys.biz_market_video_guide_sub]: '1 मिनिटाचा व्हिडिओ पहा आणि शिका • YouTube Guide',
  [LangKeys.item_video_guide_btn_sub]: "स्टोअर आणि प्रॉडक्ट ऑनलाइन सक्रिय करण्याचे मार्गदर्शन",
  [LangKeys.service_video_guide_btn_sub]: "काम आणि दुकान ऑनलाइन सक्रिय करण्याचे मार्गदर्शन",
  [LangKeys.item_marketplace_title]: "ऑनलाइन बाजार (Marketplace)",
  [LangKeys.item_marketplace_sub_active]: "हे प्रॉडक्ट परिसरातील ग्राहकांना ऑनलाइन दिसेल, ते तुमच्याशी थेट संपर्क साधू शकतील आणि WhatsApp वर ऑर्डर करू शकतील.",
  [LangKeys.item_marketplace_sub_inactive]: "हे उत्पादन फक्त तुमच्या खाजगी खात्यात राहील.",
  [LangKeys.service_marketplace_sub_active]: "ही सेवा परिसरातील ग्राहकांना ऑनलाइन दिसेल, ते तुमच्याशी थेट संपर्क साधू शकतील आणि WhatsApp/कॉलवर बुकिंग करू शकतील.",
  [LangKeys.service_marketplace_sub_inactive]: "ही सेवा फक्त तुमच्या दुकानाच्या/फर्मच्या खाजगी खात्यात राहील.",
  [LangKeys.item_category_lbl]: "श्रेणी (Category)",
  [LangKeys.change_btn]: "बदला",
  [LangKeys.item_discount_price_lbl]: "ऑफर / सवलत दर (₹) (पर्यायी)",
  [LangKeys.item_discount_price_hint]: "उदा. 450",
  [LangKeys.service_discount_price_lbl]: "ऑफर / सवलत सेवा शुल्क (₹) (पर्यायी)",
  [LangKeys.service_discount_price_hint]: "उदा. 750",
  [LangKeys.item_desc_lbl]: "माहिती / वर्णन (पर्यायी)",
  [LangKeys.item_desc_hint]: "उत्पादनाचा ब्रँड, मॉडेल, रंग, आकार आणि मुख्य वैशिष्ट्ये लिहा (गुगल सर्चमध्ये मदत होईल)...",
  [LangKeys.service_desc_lbl]: "सेवेचे वर्णन (पर्यायी)",
  [LangKeys.service_desc_hint]: "सेवेची मुख्य वैशिष्ट्ये, कार्यपद्धती आणि अनुभव लिहा (गुगल सर्चमध्ये मदत होईल)...",
  [LangKeys.market_seo_badge]: "गुगल सर्च आणि रँकिंग",
  [LangKeys.category_picker_title]: "श्रेणी निवडा (Select Category)",
  [LangKeys.category_picker_sub_item]: "सामान कोणत्या श्रेणीतील/व्यवसायातील आहे?",
  [LangKeys.category_picker_sub_service]: "सेवा कोणत्या प्रकारची आहे?",
  [LangKeys.category_search_hint]: "श्रेणी शोधा (उदा. किराणा, दूध, कपडे...)",
  [LangKeys.no_category_found]: "कोणतीही श्रेणी आढळली नाही",
  [LangKeys.nothing_found_for]: "साठी काहीही आढळले नाही",
  [LangKeys.cat_title_general]: "सामान्य उत्पादने",
  [LangKeys.cat_sub_general]: "General Products",
  [LangKeys.cat_title_grocery]: "किराणा, रेशन व प्रोव्हिजन",
  [LangKeys.cat_sub_grocery]: "Kirana, Grocery & Provisions",
  [LangKeys.cat_title_dairy]: "डेअरी, दूध, तूप व पनीर",
  [LangKeys.cat_sub_dairy]: "Dairy, Milk, Ghee & Paneer",
  [LangKeys.cat_title_fruits_veg]: "फळे व ताजी भाजीपाला",
  [LangKeys.cat_sub_fruits_veg]: "Fresh Fruits & Vegetables",
  [LangKeys.cat_title_sweets_bakery]: "मिठाई, फरसाण व बेकरी",
  [LangKeys.cat_sub_sweets_bakery]: "Sweets, Snacks & Bakery",
  [LangKeys.cat_title_restaurant_food]: "हॉटेल, ढाबा व रेस्टॉरंट",
  [LangKeys.cat_sub_restaurant_food]: "Hotel, Food & Restaurant",
  [LangKeys.cat_title_pharmacy_medical]: "मेडिकल, औषधे व हेल्थकेअर",
  [LangKeys.cat_sub_pharmacy_medical]: "Pharmacy & Healthcare",
  [LangKeys.cat_title_agriculture_seeds]: "कृषी, खते, बियाणे व कीटकनाशके",
  [LangKeys.cat_sub_agriculture_seeds]: "Agri, Seeds & Fertilizer",
  [LangKeys.cat_title_animal_feed]: "पशुखाद्य, पेंड व आहार",
  [LangKeys.cat_sub_animal_feed]: "Cattle & Animal Feed",
  [LangKeys.cat_title_electronics_mobile]: "मोबाइल, लॅपटॉप व संगणक",
  [LangKeys.cat_sub_electronics_mobile]: "Electronics, Mobile & IT",
  [LangKeys.cat_title_electrical_appliances]: "इलेक्ट्रिकल्स व होम अप्लायन्सेस",
  [LangKeys.cat_sub_electrical_appliances]: "Electricals & Appliances",
  [LangKeys.cat_title_clothing_garments]: "कपडे, साडी व रेडिमेड",
  [LangKeys.cat_sub_clothing_garments]: "Garments, Sarees & Apparel",
  [LangKeys.cat_title_footwear_shoes]: "पादत्राणे, चप्पल व शूज",
  [LangKeys.cat_sub_footwear_shoes]: "Footwear & Shoes",
  [LangKeys.cat_title_hardware_sanitary]: "हार्डवेअर, सॅनिटरी व टूल्स",
  [LangKeys.cat_sub_hardware_sanitary]: "Hardware, Sanitary & Tools",
  [LangKeys.cat_title_building_materials]: "बांधकाम साहित्य व सिमेंट",
  [LangKeys.cat_sub_building_materials]: "Building Materials & Cement",
  [LangKeys.cat_title_automobile_parts]: "ऑटो पार्ट्स व स्पेअर्स",
  [LangKeys.cat_sub_automobile_parts]: "Automobile & Spares",
  [LangKeys.cat_title_cosmetics_beauty]: "कॉस्मेटिक्स, ब्युटी व सलून",
  [LangKeys.cat_sub_cosmetics_beauty]: "Beauty, Salon & Cosmetics",
  [LangKeys.cat_title_stationery_books]: "पुस्तके, स्टेशनरी व छपाई",
  [LangKeys.cat_sub_stationery_books]: "Books & Stationery",
  [LangKeys.cat_title_jewellery_gifts]: "सोने-चांदी व दागिने",
  [LangKeys.cat_sub_jewellery_gifts]: "Jewellery & Gifts",
  [LangKeys.cat_title_furniture_decor]: "फर्नीचर व होम डेकोर",
  [LangKeys.cat_sub_furniture_decor]: "Furniture & Home Decor",
  [LangKeys.cat_title_kitchenware_utensils]: "भांडी व किचनवेअर",
  [LangKeys.cat_sub_kitchenware_utensils]: "Kitchenware & Utensils",
  [LangKeys.cat_title_toys_sports]: "खेळणी व क्रीडा साहित्य",
  [LangKeys.cat_sub_toys_sports]: "Toys & Sports",
  [LangKeys.cat_title_packaging_disposable]: "प्लॅस्टिक व डिस्पोजेबल सामान",
  [LangKeys.cat_sub_packaging_disposable]: "Packaging & Disposables",
  [LangKeys.cat_title_tailoring_boutique]: "टेलरिंग व बुटीक",
  [LangKeys.cat_sub_tailoring_boutique]: "Tailoring & Boutique",
  [LangKeys.cat_title_meat_poultry]: "मटण, चिकन व मासे",
  [LangKeys.cat_sub_meat_poultry]: "Meat, Fish & Poultry",
  [LangKeys.cat_title_services_repair]: "दुरुस्ती व कामगार सेवा",
  [LangKeys.cat_sub_services_repair]: "Repair & Services",
  [LangKeys.cat_title_other]: "इतर सर्व वस्तू व सेवा",
  [LangKeys.cat_sub_other]: "Other Products & Services",
  [LangKeys.cat_title_optical_eyewear]: "चष्मा आणि ऑप्टिकल्स",
  [LangKeys.cat_sub_optical_eyewear]: "Optical & Eyewear",
  [LangKeys.cat_title_pooja_religious]: "पूजा साहित्य व अगरबत्ती",
  [LangKeys.cat_sub_pooja_religious]: "Pooja Items & Essentials",
  [LangKeys.cat_title_watches_accessories]: "घड्याळे आणि ॲक्सेसरीज",
  [LangKeys.cat_sub_watches_accessories]: "Watches & Accessories",
  [LangKeys.cat_title_generalservice]: "सामान्य सेवा (General Service)",
  [LangKeys.cat_sub_generalservice]: "All General Services & Labor",
  [LangKeys.cat_title_electronics_tv_repair]: "टीव्ही, LED व इलेक्ट्रॉनिक्स दुरुस्ती",
  [LangKeys.cat_sub_electronics_tv_repair]: "TV, LED, Music System & Electronics",
  [LangKeys.cat_title_ac_appliances_repair]: "एसी, फ्रिज, वॉशिंग मशिन व गिझर दुरुस्ती",
  [LangKeys.cat_sub_ac_appliances_repair]: "AC, Refrigerator & Home Appliances",
  [LangKeys.cat_title_electrician_wiring]: "इलेक्ट्रिशियन, वायरिंग व पंखे",
  [LangKeys.cat_sub_electrician_wiring]: "Electrician, Fitting & Rewinding",
  [LangKeys.cat_title_plumbing_sanitary]: "प्लंबर, नळ व सॅनिटरी फिटिंग",
  [LangKeys.cat_sub_plumbing_sanitary]: "Plumber & Sanitary Fitting",
  [LangKeys.cat_title_tailoring_stitching]: "शिलाई, टेलरिंग व बुटीक",
  [LangKeys.cat_sub_tailoring_stitching]: "Tailoring, Stitching & Boutique",
  [LangKeys.cat_title_mobile_laptop_repair]: "मोबाइल, लॅपटॉप व संगणक दुरुस्ती",
  [LangKeys.cat_sub_mobile_laptop_repair]: "Mobile, Laptop & Desktop Service",
  [LangKeys.cat_title_automobile_mechanic]: "कार, बाईक सर्व्हिसिंग व वॉशिंग",
  [LangKeys.cat_sub_automobile_mechanic]: "Car, Bike & Auto Mechanic / Washing",
  [LangKeys.cat_title_beauty_parlour_salon]: "ब्युटी पार्लर, सलून व मेकओव्हर",
  [LangKeys.cat_sub_beauty_parlour_salon]: "Beauty Parlour, Salon & Bridal",
  [LangKeys.cat_title_carpenter_woodwork]: "सुतार / कारपेंटर व लाकडी काम",
  [LangKeys.cat_sub_carpenter_woodwork]: "Carpenter, Furniture & Woodwork",
  [LangKeys.cat_title_painting_whitewash]: "पेंटिंग, पुट्टी व रंगकाम",
  [LangKeys.cat_sub_painting_whitewash]: "Wall Painting, Putty & Polish",
  [LangKeys.cat_title_construction_civil]: "बांधकाम, कंत्राटदार व गवंडी",
  [LangKeys.cat_sub_construction_civil]: "Civil Contractor, Mason & Labour",
  [LangKeys.cat_title_agri_motor_tractor]: "ट्रॅक्टर, मोटर व पंप दुरुस्ती",
  [LangKeys.cat_sub_agri_motor_tractor]: "Tractor, Water Pump & Agri Motors",
  [LangKeys.cat_title_cctv_security_install]: "सीसीटीव्ही व सुरक्षा यंत्रणा",
  [LangKeys.cat_sub_cctv_security_install]: "CCTV Camera & Security Fitting",
  [LangKeys.cat_title_cleaning_pest_control]: "क्लिनिंग, टाकी स्वच्छता व पेस्ट कंट्रोल",
  [LangKeys.cat_sub_cleaning_pest_control]: "Deep Cleaning, Water Tank & Pest",
  [LangKeys.cat_title_transport_loading]: "वाहतूक, लोडिंग व ट्रान्सपोर्ट",
  [LangKeys.cat_sub_transport_loading]: "Transport, Loading & Movers",
  [LangKeys.cat_title_photography_video]: "फोटोग्राफी व व्हिडिओग्राफी",
  [LangKeys.cat_sub_photography_video]: "Photo, Video & Studio Services",
  [LangKeys.cat_title_events_catering_tent]: "मंडप, केटरिंग, डीजे व साउंड",
  [LangKeys.cat_sub_events_catering_tent]: "Tent, Catering, DJ & Events",
  [LangKeys.cat_title_education_tuition]: "कोचिंग, शिकवणी व क्लासेस",
  [LangKeys.cat_sub_education_tuition]: "Tuition & Education Classes",
  [LangKeys.cat_title_ca_tax_csc_emitra]: "सीए, टॅक्स व ऑनलाइन सेवा",
  [LangKeys.cat_sub_ca_tax_csc_emitra]: "CA, Tax, CSC, E-Mitra & Online Forms",
  [LangKeys.cat_title_healthcare_clinic_lab]: "डॉक्टर, क्लिनिक व लॅब टेस्ट",
  [LangKeys.cat_sub_healthcare_clinic_lab]: "Doctor, Nursing & Diagnostics",
  [LangKeys.cat_title_other_service]: "इतर सर्व कुशल सेवा व कारागिरी",
  [LangKeys.cat_sub_other_service]: "Other Services & Skilled Work",
  [LangKeys.cat_title_transport_taxi]: "टॅक्सी आणि टूर ट्रॅव्हल्स",
  [LangKeys.cat_sub_transport_taxi]: "Taxi & Tour Travels",
  [LangKeys.cat_title_legal_advocate]: "वकील आणि कायदेशीर सल्ला",
  [LangKeys.cat_sub_legal_advocate]: "Legal & Advocate Services",
  [LangKeys.cat_title_packers_movers]: "पॅकर्स अँड मूव्हर्स",
  [LangKeys.cat_sub_packers_movers]: "Packers & Movers",
  [LangKeys.cat_title_printing_flex_banner]: "प्रिंटिंग आणि फ्लेक्स बोर्ड",
  [LangKeys.cat_sub_printing_flex_banner]: "Printing & Flex Banner",
  [LangKeys.cat_title_gym_fitness_yoga]: "जिम, फिटनेस आणि योग",
  [LangKeys.cat_sub_gym_fitness_yoga]: "Gym, Fitness & Yoga",
  [LangKeys.cat_title_cook_maid_househelp]: "कूक आणि घरगुती मदतनीस",
  [LangKeys.cat_sub_cook_maid_househelp]: "Cook & Domestic Help",
  [LangKeys.item_photo_guide_verified]: "फोटो जोडला • Tier-1 टॉप लिस्टिंग",
  [LangKeys.item_photo_guide_why_add]: "फोटो का जोडावा? (5x जास्त विक्री)",
  [LangKeys.service_photo_guide_why_add]: "फोटो का जोडावा? (5x जास्त बुकिंग)",
  [LangKeys.item_photo_guide_desc]: "स्वच्छ प्रकाशातील व स्पष्ट PNG/JPG फोटो लावा. फोटो नसलेल्या वस्तूंपेक्षा फोटो असलेले प्रॉडक्ट्स ऑनलाइन बाजारात सर्वात वर (Tier-1) दिसतात.",
  [LangKeys.service_photo_guide_desc]: "आपल्या कामाचे, हत्यारांचे किंवा दुकानाचे स्पष्ट PNG/JPG फोटो लावा. फोटो नसलेल्यांपेक्षा फोटो असलेल्या सेवा जवळच्या ग्राहकांना सर्वात वर (Tier-1) दिसतात.",
  [LangKeys.item_video_guide_btn_title]: "ऑनलाइन लिस्टिंग शिका (5 मिनिट व्हिडिओ)",
  [LangKeys.service_video_guide_btn_title]: "सर्व्हिस लिस्टिंग शिका (5 मिनिट व्हिडिओ)",
  [LangKeys.market_format_bold]: "𝗕 ठळक (*नाव*)",
  [LangKeys.market_format_bullet]: "• बुलेट पॉईंट",
  [LangKeys.market_format_highlight]: "⭐ मुख्य वैशिष्ट्ये",
  [LangKeys.market_format_warranty_item]: "📦 वॉरंटी / तपशील",
  [LangKeys.market_format_warranty_service]: "📦 वॉरंटी / हमी",
  [LangKeys.market_format_template_item]: "⚡ तयार ब्लॉग टेम्पलेट",
  [LangKeys.market_format_template_service]: "⚡ तयार सर्व्हिस टेम्पलेट",
  [LangKeys.market_seo_tip_item]: "तपशीलवार वर्णन लिहिल्याने तुमचे उत्पादन गुगल सर्च आणि ऑनलाइन मार्केटमध्ये ग्राहकांना वेगाने दिसेल.",
  [LangKeys.market_seo_tip_service]: "तपशीलवार वर्णन लिहिल्याने तुमची सेवा गुगल सर्च आणि ऑनलाइन मार्केटमध्ये ग्राहकांना वेगाने दिसेल.",
  [LangKeys.crop_photo_title]: "फोटो क्रॉप आणि ॲडजस्ट करा",
  [LangKeys.crop_product_photo]: "प्रॉडक्ट फोटो क्रॉप आणि ॲડजस्ट करा",
  [LangKeys.crop_service_photo]: "सर्व्हिस फोटो क्रॉप आणि ॲડजस्ट करा",
  [LangKeys.crop_drag_hint]: "बोटाने किंवा माऊसने फोटो हलवा / ड्रॅग करा",
  [LangKeys.crop_rotate_left]: "90° डावीकडे",
  [LangKeys.crop_rotate_right]: "90° उजवीकडे",
  [LangKeys.crop_reset]: "रीसेट",
  [LangKeys.crop_ratio_square]: "1:1 (चौकोनी)",
  [LangKeys.crop_ratio_standard]: "4:3 (प्रमाणित)",
  [LangKeys.crop_ratio_free]: "Free (मुक्त)",
  [LangKeys.crop_save_done]: "क्रॉप आणि सेव्ह करा (Done)",
  [LangKeys.crop_compressing]: "कंप्रेस होत आहे...",
  [LangKeys.party_or_details]: "पार्टी / तपशील",
  [LangKeys.report_copied_clipboard]: "अहवालाचा तपशील क्लिपबोर्डवर कॉपी झाला आहे!",
  [LangKeys.party]: "पार्टी",
  [LangKeys.sale]: "विक्री",
  [LangKeys.purchase]: "खरेदी",
  [LangKeys.expense]: "खर्च",
  [LangKeys.ai_support_btn]: "AI सपोर्टशी त्वरित चॅट करा (24x7 Live)",
  [LangKeys.ai_support_title]: "Moxpal AI सपोर्ट",
  [LangKeys.ai_support_online_status]: "● 24x7 त्वरित मदत",
  [LangKeys.ai_support_welcome_msg]: "नमस्ते! 🙏 मी *Moxpal Khata* चा स्मार्ट AI सहाय्यक आहे.\\n\\nमी तुमचे खाते, बिलिंग, डेअरी पासबुक किंवा सबस्क्रिप्शन प्लॅनशी संबंधित सर्व प्रश्नांमध्ये मदत करण्यास तयार आहे. तुम्हाला काय जाणून घ्यायचे आहे?",
  [LangKeys.ai_support_input_hint]: "तुमचा प्रश्न किंवा अडचण येथे विचारा...",
  [LangKeys.ai_support_typing]: "AI सहाय्यक उत्तर लिहीत आहे...",
  [LangKeys.ai_support_copied]: "संदेश कॉपी केला गेला",
  [LangKeys.ai_support_net_error]: "इंटरनेट कनेक्शनमध्ये समस्या येत आहे. कृपया नेटवर्क तपासा.",
  [LangKeys.ai_support_server_error]: "सर्व्हरशी कनेक्ट करताना समस्या आली. कृपया पुन्हा प्रयत्न करा किंवा WhatsApp वर संपर्क साधा.",
  [LangKeys.ai_support_sugg_plan]: "💎 प्लॅनचे काय फायदे आहेत?",
  [LangKeys.ai_support_sugg_dairy]: "🥛 डेअरी पासबुक कसे वापरावे?",
  [LangKeys.ai_support_sugg_party]: "👥 नवीन ग्राहक/खाते कसे जोडावे?",
  [LangKeys.ai_support_sugg_backup]: "💾 डेटा बॅकअप कसा घ्यावा?",
  [LangKeys.ai_support_sugg_bill]: "🧾 नवीन बिल कसे बनवावे?",
  [LangKeys.ai_support_clear_chat]: "नवीन संभाषण सुरू करा",
  [LangKeys.ai_support_clear_title]: "चॅट इतिहास हटवायचा?",
  [LangKeys.ai_support_clear_confirm]: "तुम्हाला जुनी संभाषणे हटवून नवीन चॅट सुरू करायची आहे का?",
  [LangKeys.help_center_title]: "Moxpal Khata Help Center",
  [LangKeys.help_center_sub]: "वारंवार विचारले जाणारे प्रश्न, ट्यूटोरियल्स आणि ग्राहक समर्थनाचे केंद्र",
  [LangKeys.help_support_title]: "मदत आणि सपोर्ट",
  [LangKeys.help_center_heading]: "Moxpal Khata Help Center",
  [LangKeys.help_center_subheading]: "FAQs, ट्यूटोरियल्स आणि ग्राहक समर्थनासाठी तुमचे वन-स्टॉप केंद्र",
  [LangKeys.help_ai_title]: "Moxpal AI Support",
  [LangKeys.help_ai_live_badge]: "24x7 LIVE",
  [LangKeys.help_ai_online_status]: "• 24x7 झटपट सपोर्ट",
  [LangKeys.help_ai_desc]: "खाते, बिलिंग, इन्व्हेंटरी, डेअरी पासबुक किंवा प्लॅनशी संबंधित सर्व प्रश्नांची झटपट AI उत्तरे मिळवा.",
  [LangKeys.help_ai_chat_btn]: "Chat with AI Support (24x7 Live)",
  [LangKeys.help_whatsapp_title]: "Contact Us (WhatsApp)",
  [LangKeys.help_whatsapp_sub]: "+91 99293 71541 • अधिकृत सपोर्ट टीम",
  [LangKeys.help_call_title]: "कॉल हेल्पलाइन",
  [LangKeys.help_call_number]: "+91 9166277283",
  [LangKeys.help_email_title]: "ईमेल सपोर्ट",
  [LangKeys.help_email_id]: "support@moxpal.com",
  [LangKeys.help_faq_title]: "वारंवार विचारले जाणारे प्रश्न (FAQs)",
  [LangKeys.help_faq_1_q]: "खात्यात नवीन ग्राहक किंवा पुरवठादार कसा जोडावा?",
  [LangKeys.help_faq_1_a]: "होम स्क्रीनवर \"Add Customer\" बटण दाबा, नाव आणि मोबाईल नंबर टाका आणि सेव्ह करा.",
  [LangKeys.help_faq_2_q]: "डेअरी पासबुकमध्ये दूध संकलन नोंद कशी करावी?",
  [LangKeys.help_faq_2_a]: "डेअरी विभागात जा, \"दूध नोंद\" निवडा, फॅट/SNF किंवा थेट दर टाकून 1-क्लिकमध्ये पावती पाठवा.",
  [LangKeys.help_faq_3_q]: "डेटा बॅकअप कसा सुरक्षित राहतो?",
  [LangKeys.help_faq_3_a]: "मोक्षपाल खात्यावर तुमचा सर्व डेटा क्लाउड सर्व्हरवर 100% एन्क्रिप्टेड आणि सुरक्षित राहतो.",
  [LangKeys.help_faq_4_q]: "सदस्यता प्लॅन कसा अपग्रेड करावा?",
  [LangKeys.help_faq_4_a]: "सेटिंग्जमध्ये \"माझी सदस्यता\" वर जा आणि तुमचा आवडता प्लॅन निवडून सुरक्षित पेमेंट करा.",
  [LangKeys.help_footer_call_hours]: "कॉल सपोर्ट: सोम - शनि (सकाळी 9:00 ते रात्री 8:00)",
  [LangKeys.help_footer_ai_hours]: "AI चॅट सहाय्यक: 24 तास 365 दिवस त्वरित मदत",
  [LangKeys.help_footer_branding]: "Moxpal Technologies • 100% सुरक्षित आणि विश्वासार्ह • Made in India 🇮🇳",
  [LangKeys.help_feature_launch_error]: "सुविधा उघडण्यास असमर्थ",
};

export default mr;